import iioniconaalertcircleoutline from "../../assets/dashboard/ioniconaalertcircleoutline-1.svg";
import { FunctionComponent, useEffect, useMemo, useRef, useState } from "react";
import { getSupabaseExt } from "../../lib/supabase";
import { SortingState } from "@tanstack/react-table";
import {
  ApolloError,
  useApolloClient,
  useLazyQuery,
  useMutation,
  useQuery,
} from "@apollo/client";
import firsflag1 from "../../assets/dashboard/firsflag-11.svg";
import viewIcon from "../../assets/dashboard/visibility.png";
import resolvedIcon from "../../assets/dashboard/check-mark.png";
import resssignIcon from "../../assets/dashboard/user-replace.png";
import ViewTaskicon from "../../assets/dashboard/visibility.png";
import { format, parse, subDays } from "date-fns";
import { showError, showSuccess } from "../common/ToastNotification";
import { useAuth } from "../../context/AuthContext";
import SkeletonLoader from "../common/SkeletonLoader";
import {
  CREATE_GOAL,
  CREATE_POD_GOAL,
  PATCH_DEFECT,
  REASSIGN_DEFECT_GOAL,
  REASSIGN_POD_GOAL,
  RESOLVE_DEFECT,
  UPDATE_DEFECT,
  UPDATE_DEPENDENCY,
} from "../../api/mutation";
import DynamicTable from "../common/DynamicTable";
import {
  BUGS,
  DEFECT_HISTORY,
  DEFECTS,
  DELAYS,
  DEPENDENCIES,
  EMPLOYEES_BY_AGENCY_ID,
  ENHANCEMENTS,
  GET_ALL_SKILLS,
  GOAL_MASTER_DATA,
  LEAVES_BY_AGENCY,
  PODS_DATA,
  PROJECTS_BY_EMP_ID,
  TODAY_BREAKS_BY_AGENCY,
  UPCOMING_FEATURES,
} from "../../api/query";
import {
  buildBugGoalPayload,
  buildCustomerFollowupGoalPayload,
  buildEnhancementGoalPayload,
  buildTrainingIssueGoalPayload,
  DEFAULT_BUG_SKILL_NAMES,
  findBugGoalStatic,
  findCustomerFollowupGoalStatic,
  findEnhancementGoalStatic,
  findTrainingIssueGoalStatic,
} from "../../utils/defectGoalUtils";
import { useNavigate } from "react-router-dom";
import ioniconaaddoutline from "../../assets/dashboard/ioniconaaddoutline.svg";
import NotifyPopup from "./NotifyPopup";
import InputsDropdown from "../common/InputsDropdown";
import DefectEmailModal from "../../pages/defect/DefectEmailModal";
import BugModal from "../../pages/bug/BugModal";
import BugResolveModal from "../../pages/bug/BugResolveModal";
import SearchableInputsDropdown from "../common/SearchableDropdown";


const statusValues = [
  { id: 4, name: "In Progress", type: "task_status", value: 2 },
  { id: 5, name: "Testing", type: "task_status", value: 4 },
  { id: 6, name: "Closed", type: "task_status", value: 6 },
  { id: 3, name: "Not Started", type: "task_status", value: 1 },
  { id: 8, name: "On Hold", type: "task_status", value: 3 },
];

const TRAINING_ISSUE_TASK_OPTIONS = [
  {
    key: "validate",
    name: "Triage",
  },
  {
    key: "fix",
    name: "Unblock her now",
  },
  {
    key: "check",
    name: "What was missing",
  },
];


interface DashAlertProps {
  alertLabel: string | undefined;
  refetchCounter?: any;
}

const parseAsUTC = (dateStr: string) => {
  // Agar already 'Z' ya offset (+/-) present hai to as-is chodo, warna 'Z' add karo
  const hasTimezone = /[Zz]|[+-]\d{2}:\d{2}$/.test(dateStr);
  return new Date(hasTimezone ? dateStr : `${dateStr}Z`);
};

const DashAlert: FunctionComponent<DashAlertProps> = ({
  alertLabel,
  refetchCounter,
}) => {
  const navigate = useNavigate();

  const [sorting, setSorting] = useState<SortingState>([]);
  const [selectedRows, setSelectedRows] = useState<Set<string>>(new Set());
  const [mainTable, setMainTable] = useState<any>(null);
  const [mainTableUpdate, setMainTableUpdate] = useState(false);
  const [alertOrAction, setAlertOrAction] = useState("alert");
  const [currentPage, setCurrentPage] = useState(1);
  const currentPageRef = useRef(1);
  useEffect(() => { currentPageRef.current = currentPage; }, [currentPage]);
  const [pageSize, setPageSize] = useState(100);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [dependencyToShow, setDependencyToShow] = useState("");
  const [bugStatusFilter, setBugStatusFilter] = useState<string>("Open");
  const [enhancmentStatusFilter, setEnhancmentStatusFilter] =
    useState<string>("Open");
      const [followUpStatusFilter, setFollowUpStatusFilter] =
    useState<string>("Open");
     const [trainingStatusFilter, setTrainingStatusFilter] =
    useState<string>("Open");
  const [openDefectEmail, setOpenDefectEmail] = useState("");
  const [openDemo, setOpenDemo] = useState("");

  const [demoData, setDemoData] = useState<any[]>([]);
  const [demoLoading, setDemoLoading] = useState(false);
  const [demoFilter, setDemoFilter] = useState<string>("Open");
  const [assignedMemberOptions, setAssignedMemberOptions] = useState<
    { key: string; name: string }[]
  >([]);

  // For the agent api
  const [loading, setLoading] = useState<Boolean>(false);

  // Auto-create bug goal state
  const [autoCreatingDefectId, setAutoCreatingDefectId] = useState<string | null>(null);

  // Bug resolve modal state
  const [bugResolveDefect, setBugResolveDefect] = useState<any>(null);
  const [defectResolveRow, setDefectResolveRow] = useState<any>(null);
  const [enhancementResolveRow, setEnhancementResolveRow] = useState<any>(null);
  const [viewNotesDefect, setViewNotesDefect] = useState<any>(null);
  const [demoResolveRow, setDemoResolveRow] = useState<any>(null);
  const [demoResolveLoading, setDemoResolveLoading] = useState(false);
  const [reassignAlert, setReassignAlert] = useState<any>(null);
  const [reassignPod, setReassignPod] = useState<any>(null);
  const [reassignActionType, setReassignActionType] = useState<string>("");
  const [reassignSaving, setReassignSaving] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);

  // const { userInfo } = useContext<any>(UserContext)
  const { userInfo } = useAuth();
  const employeeID = userInfo?.employee_id;
  const agencyID = userInfo?.agencies?.id;

  const client = useApolloClient();
const [createPodGoal] = useMutation(CREATE_POD_GOAL, {
  fetchPolicy: "no-cache",
});
const [updateDefect] = useMutation(UPDATE_DEFECT, {
  fetchPolicy: "no-cache",
});



  const [createGoal] = useMutation(CREATE_GOAL, { fetchPolicy: "no-cache" });
  const [patchDefect] = useMutation(PATCH_DEFECT, { fetchPolicy: "no-cache" });
  const [reassignDefectGoal, { loading: reassignMutationLoading }] = useMutation(REASSIGN_DEFECT_GOAL, { fetchPolicy: "no-cache" });
  const [reassignDefectGoalPOD, { loading: reassignMutationLoadingPOD }] = useMutation(REASSIGN_POD_GOAL, { fetchPolicy: "no-cache" });
const [trainingIssuePopupOpen, setTrainingIssuePopupOpen] = useState(false);
const [selectedTrainingIssueRow, setSelectedTrainingIssueRow] = useState<any>(null);
const [reassignTrainingIssuePopupOpen, setReassignTrainingIssuePopupOpen] = useState(false);
const [reassignTaskTag, setReassignTaskTag] = useState<string>("");
const [updatingPodDefectId, setUpdatingPodDefectId] = useState<string | null>(null);
  const [projects, setProjects] = useState<any[]>([]);
  const [getDefectHistory, { data: historyData, loading: historyLoading }] = useLazyQuery(DEFECT_HISTORY, {
    fetchPolicy: "no-cache",
    onError: (err) => showError(err.message),
  });

    const {  loading: projectsDataLoading } = useQuery(
      PROJECTS_BY_EMP_ID,
      {
        fetchPolicy: "no-cache",
        variables: {
          emp_id: "1000004",
          organization_id: "3",
        },
            onCompleted: (data: any) => {
        const options =
          data?.projects_by_emp_id?.map((emp: any) => ({
            key: emp.id,
            name: emp.name,
          })) || [];
  
        setProjects(options);
      },
      },
    );

  //api
  const [
    getDependencies,
    { data: dependencyData, loading: dependencyDataLoading },
  ] = useLazyQuery(DEPENDENCIES, {
    fetchPolicy: "no-cache",
  });

  const [getDelays, { data: delaysData, loading: delaysDataLoading }] =
    useLazyQuery(DELAYS, {
      fetchPolicy: "no-cache",
    });

  const [getDefects, { data: defectsData, loading: defectsDataLoading }] =
    useLazyQuery(DEFECTS, {
      fetchPolicy: "no-cache",
    });

  const [updateDependency, { loading: updateDependencyLoading }] = useMutation(
    UPDATE_DEPENDENCY,
    {
      fetchPolicy: "no-cache",
    },
  );

  const [resolveDefect, { loading: resolveDefectLoading }] = useMutation(
    RESOLVE_DEFECT,
    {
      fetchPolicy: "no-cache",
    },
  );

  const [leavesByAgency, { data: leavesData, loading: leavesDataLoading }] =
    useLazyQuery(LEAVES_BY_AGENCY, {
      fetchPolicy: "no-cache",
    });

  const [breaksByAgency, { data: breakData, loading: breakDataLoading }] =
    useLazyQuery(TODAY_BREAKS_BY_AGENCY, {
      fetchPolicy: "no-cache",
    });

  const [
    getUpcomingFeatures,
    { data: upcomingFeaturesData, loading: upcomingFeaturesLoading },
  ] = useLazyQuery(UPCOMING_FEATURES, {
    fetchPolicy: "no-cache",
  });








  const now = new Date();
  const todayDate = format(now, "yyyy-MM-dd");
  const nextDayDate = format(subDays(now, -1), "yyyy-MM-dd");
  const next7DaysDate = format(subDays(now, -7), "yyyy-MM-dd");
      const [allPodsData, setAllPodsData] = useState<any[]>([]);

  async function fetchAllDemoData() {
    setDemoLoading(true);
    const { data, error } = await getSupabaseExt()
      .from("carebravosite_contact_demo_requests")
      .select("*")
      .order("created_at", { ascending: false });
    setDemoLoading(false);
    if (!error && data) {
      setDemoData(data);
    }
  }


  useEffect(() => {
  const bodyClasses = [
    "dependency_table_item",
    "delays_table_item",
    "defect_table_item",
    "demo_request_table_item",
    "upcoming_features_table_item",
    "todays_leave_table_item",
    "upcoming_leave_table_item",
    "breaks_table_item",
    "bugs_table_item",
    "enhancements_table_item",
    "follow_up_table_item",
    "training_issue_table_item",
  ];

  document.body.classList.remove(...bodyClasses);

  switch (alertLabel) {
    case "Dependency":
      document.body.classList.add("dependency_table_item");
      break;
    case "Delays":
      document.body.classList.add("delays_table_item");
      break;
    case "Defect":
      document.body.classList.add("defect_table_item");
      break;
    case "Demo Request":
      document.body.classList.add("demo_request_table_item");
      break;
    case "Upcoming Features":
      document.body.classList.add("upcoming_features_table_item");
      break;
    case "Today's Leave":
      document.body.classList.add("todays_leave_table_item");
      break;
    case "Upcoming Leave":
      document.body.classList.add("upcoming_leave_table_item");
      break;
    case "Breaks":
      document.body.classList.add("breaks_table_item");
      break;
    case "Bugs":
      document.body.classList.add("bugs_table_item");
      break;
    case "Enhancements":
      document.body.classList.add("enhancements_table_item");
      break;
    case "Follow Up":
      document.body.classList.add("follow_up_table_item");
      break;
    case "Training Issue":
      document.body.classList.add("training_issue_table_item");
      break;
    default:
      break;
  }

  return () => {
    document.body.classList.remove(...bodyClasses);
  };
}, [alertLabel]);

 useEffect(() => {
    if (agencyID) {
            const today = format(new Date(), 'yyyy-MM-dd');
            fetchPods({
                variables: {
                    agency_id: parseInt(agencyID),
                    start_date: today,
                    end_date: today,
                },
            }).then((res:any)=>{
              const data =res?.data?.pods_data?.data
              setAllPodsData(data)
            })    
    }
  }, [agencyID]);

  const { loading: employeesDataLoading } = useQuery(EMPLOYEES_BY_AGENCY_ID, {
    variables: {
      agency_id: parseInt(agencyID),
    },
    skip: !agencyID,
    fetchPolicy: "no-cache",
    onCompleted: (data: any) => {
      const employeeOptions =
        data?.employees_by_agency_id?.employees?.map((emp: any) => ({
          key: emp.employee_id,
          name: `${emp.first_name} ${emp.last_name}`,
        })) || [];

      setAssignedMemberOptions(employeeOptions);
    },
  });

  useEffect(() => {
    setCurrentPage(1);
    setPageSize(100);
    if (alertLabel === "Dependency") {
      getDependencies({
        variables: {
          page: 1,
          page_size: 100,
        },
      });

      // setAlertOrAction("action")
      setAlertOrAction("alert");
    } else if (alertLabel === "Delays") {
      getDelays({
        variables: {
          date: todayDate,
          page: 1,
          page_size: 100,
        },
      });

      // setAlertOrAction("action")
      setAlertOrAction("alert");
    } else if (alertLabel === "Defect") {
      getDefects({
        variables: {
          page: 1,
          page_size: 100,
          is_confirmed: true,
          is_issue: true,
          is_resolved: false,
          filter_input: "Defects",
        },
      });

      // setAlertOrAction("action")
      setAlertOrAction("alert");
    } else if (alertLabel === "Today's Leave") {
      leavesByAgency({
        variables: {
          agency_id: agencyID,
          start_date: `${todayDate}T00:00:00Z`,
          end_date: `${todayDate}T23:59:59Z`,
          leave_status: ["Approved", "Pending"],
        },
      });

      // setAlertOrAction("action")
      setAlertOrAction("alert");
    } else if (alertLabel === "Upcoming Leave") {
      leavesByAgency({
        variables: {
          agency_id: agencyID,
          start_date: `${nextDayDate}T00:00:00Z`,
          end_date: `${next7DaysDate}T23:59:59Z`,
          leave_status: ["Approved", "Pending"],
        },
      });

      // setAlertOrAction("action")
      setAlertOrAction("alert");
    } else if (alertLabel === "Breaks") {
      breaksByAgency({
        variables: {
          agency_id: parseInt(agencyID),
        },
      });

      // setAlertOrAction("action")
      setAlertOrAction("alert");
    } else if (alertLabel === "Upcoming Features") {
      const paginationInput = {
        page: 1,
        page_size: 100,
      };

      getUpcomingFeatures({
        variables: {
          outcome: ["Build Something New"],
          pagination_input: paginationInput,
        },
      });

      // setAlertOrAction("action")
      setAlertOrAction("alert");
    } else if (alertLabel === "Bugs") {
      setBugStatusFilter("Open")
      getDefects({
        variables: {
          page: 1,
          page_size: 100,
          is_confirmed: true,
          is_issue: true,
          is_resolved: false,
          filter_input: "Bug",
        },
      });

      setAlertOrAction("alert");
    } else if (alertLabel === "Enhancements") {
        setEnhancmentStatusFilter("Open")
      getDefects({
        variables: {
          page: 1,
          page_size: 100,
          is_confirmed: true,
          is_issue: true,
          is_resolved: false,
          filter_input: "Enhancement",
        },
      });

      setAlertOrAction("alert");
    } else if (alertLabel === "Follow Up") {
            setFollowUpStatusFilter("Open")
      getDefects({
        variables: {
          page: 1,
          page_size: 100,
          is_confirmed: true,
          is_issue: true,
          is_resolved: false,
          filter_input: "Follow up",
        },
      });

      setAlertOrAction("alert");
    }else if (alertLabel === "Training Issue") {
      setTrainingStatusFilter("Open")
      getDefects({
        variables: {
          page: 1,
          page_size: 100,
          is_confirmed: true,
          is_issue: true,
          is_resolved: false,
          filter_input: "Training Issue",
        },
      });

      setAlertOrAction("alert");
    }else if (alertLabel === "Demo Request") {
      setDemoFilter("Open");
      setAlertOrAction("alert");
      fetchAllDemoData();
    }
  }, [alertLabel]);

  // Re-fetch bugs when status filter changes
  useEffect(() => {
    if (alertLabel === "Bugs") {
      setCurrentPage(1);
    getDefects({
        variables: {
          page: 1,
          page_size: pageSize,
          is_confirmed: true,
          is_issue: true,
          is_resolved: bugStatusFilter == "All" ? null : bugStatusFilter == "Open" ?   false  : true,
          filter_input: "Bug",
            ...((bugStatusFilter === "Customer Approval" || bugStatusFilter === "Closed") && {
          is_approved: bugStatusFilter === "Closed" ? true : false,
        }),

        },
      });
    }
  }, [bugStatusFilter]);

  // Re-fetch enhancements when status filter changes
  useEffect(() => {
    if (alertLabel === "Enhancements") {
     setCurrentPage(1);
    getDefects({
        variables: {
          page: 1,
          page_size: pageSize,
          is_confirmed: true,
          is_issue: true,
          is_resolved: enhancmentStatusFilter == "All" ? null : enhancmentStatusFilter == "Open" ?   false  : true,
          filter_input: "Enhancement",
              ...((enhancmentStatusFilter === "Customer Approval" || enhancmentStatusFilter === "Closed") && {
          is_approved: enhancmentStatusFilter === "Closed" ? true : false,
        }),
        },
      });
    }
  }, [enhancmentStatusFilter]);

    // Re-fetch Follow Up when status filter changes
  useEffect(() => {
    if (alertLabel === "Follow Up") {
     setCurrentPage(1);
    getDefects({
        variables: {
          page: 1,
          page_size: pageSize,
          is_confirmed: true,
          is_issue: true,
          is_resolved: followUpStatusFilter == "All" ? null : followUpStatusFilter == "Open" ?   false  : true,
          filter_input: "Follow up",
               ...((followUpStatusFilter === "Customer Approval" || followUpStatusFilter === "Closed") && {
          is_approved: followUpStatusFilter === "Closed" ? true : false,
        }),
        },
      });
    }
  }, [followUpStatusFilter]);

     // Re-fetch Training Issue when status filter changes
  useEffect(() => {
    if (alertLabel === "Training Issue") {
     setCurrentPage(1);
    getDefects({
        variables: {
          page: 1,
          page_size: pageSize,
          is_confirmed: true,
          is_issue: true,
          is_resolved: trainingStatusFilter == "All" ? null : trainingStatusFilter == "Open" ?   false  : true,
          filter_input: "Training Issue",
               ...((trainingStatusFilter === "Customer Approval" || trainingStatusFilter === "Closed") && {
          is_approved: trainingStatusFilter === "Closed" ? true : false,
        }),
        },
      });
    }
  }, [trainingStatusFilter]);

  useEffect(() => {
    if (alertLabel === "Demo Request") {
      setCurrentPage(1);
    }
  }, [demoFilter]);

  const getDefectActionOptions = [
    {
      key: "Bug",
      name: "Bug",
    },
    {
      key: "Enhancement",
      name: "Enhancement",
    },
    {
      key: "Training Issue",
      name: "Training Issue",
    },
    // {
    //   key: "Follow-up",
    //   name: "Follow-up",
    // },
    {
      key: "Resolve",
      name: "Resolve",
    },
  ];

  const getDefectActionOptionsGoalExist = [
    {
      key: "View task",
      name: "View task",
    },
    {
      key: "Resolve",
      name: "Resolve",
    },
  ];

    const getDefectActionOptionsGoalExistPodTemplate = [
    {
      key: "Update task",
      name: "Update task",
    },
  ];


  const formatPhoneNumber = (phoneNumber: string) => {
    if (!phoneNumber) return "";

    const cleaned = phoneNumber.replace(/\D/g, ""); // Remove any non-numeric characters
    if (cleaned.length !== 10) return phoneNumber; // If not 10 digits, return original input

    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }

    return phoneNumber;
  };
    async function handleUpdatePod(defectRow: any, newPodId: string) {
  if (updatingPodDefectId) return;

  const pod = (allPodsData ?? []).find(
    (p: any) => String(p.pod_id) === String(newPodId)
  );
  if (!pod) {
    showError("Selected pod not found.");
    return;
  }

  setUpdatingPodDefectId(String(defectRow.id));

  try {
    const response = await updateDefect({
      variables: {
  id: parseInt(defectRow.id),
        input: {
            is_issue: true,
            is_confirmed: true,  
           title: defectRow?.title || "",
           created_by: parseInt(employeeID),
          pod_id: parseInt(newPodId),
        },
      },
    });

    const result = response?.data?.update_defect;

    if (result?.status_code === 200) {
      showSuccess(result.message || "Pod updated successfully.");
      getDefects({
        variables: {
          page: currentPageRef.current,
          page_size: pageSize,
          is_confirmed: true,
          is_issue: true,
          is_resolved: false,
          filter_input: getFilterInput(),
        },
      });
      if (refetchCounter) refetchCounter();
    } else {
      showError(result?.message || "Failed to update pod.");
    }
  } catch (error) {
    if (error instanceof ApolloError) {
      showError(error.message);
    } else {
      showError("Failed to update pod. Please try again.");
    }
  } finally {
    setUpdatingPodDefectId(null);
  }
}

// Open tab me, goal bana ho to Resolve tabhi dikhao jab goal_status "Closed" ho
const canShowResolveForOpenGoal = (row: any, statusFilter: string) => {
  if (statusFilter !== "Open") return true; // Open tab nahi hai -> pehle jaisa
  if (!row?.goal_id) return true;           // goal nahi hai -> pehle jaisa
  return String(row?.goal_status || "").trim().toLowerCase() === "closed";
};

  // Function to return dynamic columns based on alertLabel
  const getColumns = (label: string | undefined) => {
    console.log(bugStatusFilter,'bugStatusFilter')
    if (label === "Dependency") {
      return [
       
        {
          key: "dependent_person_name",
          name: "Dependent On",
          id: "dependent_person_name",
          header: "Dependent On",
          accessorKey: "dependent_person_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "blocking_person_name",
          name: "Affected Person",
          id: "blocking_person_name",
          header: "Affected Person",
          accessorKey: "blocking_person_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "dependency_reason",
          name: "Reason",
          id: "dependency_reason",
          header: "Reason",
          accessorKey: "dependency_reason",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "dependency_date",
          name: "Date",
          id: "dependency_date",
          header: "Date",
          accessorKey: "dependency_date",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any) => {
            const startDateA = rowA?.getValue("dependency_date");
            const startDateB = rowB?.getValue("dependency_date");

            // If a start_date is missing (null or undefined), treat it as the latest date.
            // You can also treat missing dates as the earliest date by using `new Date(0)` instead of `new Date()`
            const defaultDate = new Date(0); // You can change this to `new Date()` if you want it sorted to the end.

            const dateA = startDateA
              ? parse(startDateA, "MM-dd-yyyy", new Date())
              : defaultDate;
            const dateB = startDateB
              ? parse(startDateB, "MM-dd-yyyy", new Date())
              : defaultDate;

            // Ensure valid date parsing, otherwise fallback to defaultDate
            if (isNaN(dateA.getTime())) {
              dateA.setTime(defaultDate.getTime());
            }
            if (isNaN(dateB.getTime())) {
              dateB.setTime(defaultDate.getTime());
            }

            // Compare the full dates directly (ascending or descending will be handled by react-table)
            return dateA.getTime() - dateB.getTime();
          },
        },
        {
          key: "action",
          name: "Action",
          id: "action",
          header: "Action",
          accessorKey: "action",
          hideSearch: true,
          cell: ({ row }: any) => {
            const original = row.original;
            const canResolve =
              employeeID == original.dependent_person_id ||
              employeeID == original.blocking_person_id;

            return (
              <div className="flex items-center gap-[8px] theme_btn_item">
                {canResolve && (
                  <button
                  title="Resolve"
                    className="dash-action-link present-bg cursor-pointer viewbtn-tooltip-item"
                    onClick={() => {
                      // handleResolveClick(original.dependency_id)
                      setIsPopupOpen(true);
                      setDependencyToShow(original.dependency_id);
                    }}
                  >
                      <span className="text-sm dark:text-white"> <img src={resolvedIcon} className=" w-4 h-6 object-contain" alt="" /></span> 
                    {/* <span className="text-sm dark:text-white"> Resolve</span> */}
                  </button>
                )}

                {row.original.dependency_task_id && (
                  <button
                    title="View Task"
                    className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                    onClick={() => {
                      navigate("/task_detail", {
                        state: {
                          taskId: row.original.dependency_task_id,
                        },
                      });
                    }}
                  >
                    <span className="text-sm dark:text-white"> <img src={ViewTaskicon} className=" w-5 h-6 object-contain" alt="" /></span> 
                    {/* <span className="text-sm dark:text-white"> View Task</span> */}
                  </button>
                )}
              </div>
            );
          },
        },
      ];
    } else if (label === "Delays") {
      return [
       
        {
          key: "task_name",
          name: "Task Name",
          id: "task_name",
          header: "Task Name",
          accessorKey: "task_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "project_name",
          name: "Project Name",
          id: "project_name",
          header: "Project Name",
          accessorKey: "project_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "goal_name",
          name: "Goal Name",
          id: "goal_name",
          header: "Goal Name",
          accessorKey: "goal_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "assigned_to_name",
          name: "Assigned To",
          id: "assigned_to_name",
          header: "Assigned To",
          accessorKey: "assigned_to_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "due_date",
          name: "Due Date",
          id: "due_date",
          header: "Due Date",
          accessorKey: "due_date",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any) => {
            const startDateA = rowA?.getValue("due_date");
            const startDateB = rowB?.getValue("due_date");

            // If a start_date is missing (null or undefined), treat it as the latest date.
            // You can also treat missing dates as the earliest date by using `new Date(0)` instead of `new Date()`
            const defaultDate = new Date(0); // You can change this to `new Date()` if you want it sorted to the end.

            const dateA = startDateA
              ? parse(startDateA, "MM-dd-yyyy", new Date())
              : defaultDate;
            const dateB = startDateB
              ? parse(startDateB, "MM-dd-yyyy", new Date())
              : defaultDate;

            // Ensure valid date parsing, otherwise fallback to defaultDate
            if (isNaN(dateA.getTime())) {
              dateA.setTime(defaultDate.getTime());
            }
            if (isNaN(dateB.getTime())) {
              dateB.setTime(defaultDate.getTime());
            }

            // Compare the full dates directly (ascending or descending will be handled by react-table)
            return dateA.getTime() - dateB.getTime();
          },
        },
        {
          key: "status",
          name: "Status",
          id: "status",
          header: "Status",
          accessorKey: "status",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "action",
          name: "Action",
          id: "action",
          header: "Action",
          accessorKey: "action",
          hideSearch: true,
          cell: ({ row }: any) => {
            const original = row.original;

            return (
              <div className="flex items-center gap-[8px]  theme_btn_item">
                <button
                title="View Task"
                  className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                  onClick={() => {
                    navigate("/task_detail", {
                      state: {
                        taskId: row.original.taskID,
                      },
                    });
                  }}
                >
                  <span className="text-sm dark:text-white"> <img src={ViewTaskicon} className=" w-5 h-6 object-contain" alt="" /></span> 
                  {/* <span className="text-sm dark:text-white">View Task</span> */}
                </button>
              </div>
            );
          },
        },
      ];
    } else if (label === "Defect") {
      return [
         
        {
          key: "reporter_name",
          name: "Reporter Name",
          id: "reporter_name",
          header: "Reporter Name",
          accessorKey: "reporter_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
          cell: ({ row }: any) => {
            return (
              <div className="flex items-center gap-[8px]  theme_btn_item">
                <span
                  className="defact-click-item cursor-pointer"
                  onClick={() => setOpenDefectEmail(row.original.id)}
                >
                  {row.original.reporter_name}
                </span>
              </div>
            );
          },
        },
        {
          key: "agency_name",
          name: "Business Name",
          id: "agency_name",
          header: "Business Name",
          accessorKey: "agency_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "created_on",
          name: "Reported Date",
          id: "created_on",
          header: "Reported Date",
          accessorKey: "created_on",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any) => {
            const startDateA = rowA?.getValue("created_on");
            const startDateB = rowB?.getValue("created_on");

            // If a start_date is missing (null or undefined), treat it as the latest date.
            // You can also treat missing dates as the earliest date by using `new Date(0)` instead of `new Date()`
            const defaultDate = new Date(0); // You can change this to `new Date()` if you want it sorted to the end.

            const dateA = startDateA
              ? parse(startDateA, "MM-dd-yyyy", new Date())
              : defaultDate;
            const dateB = startDateB
              ? parse(startDateB, "MM-dd-yyyy", new Date())
              : defaultDate;

            // Ensure valid date parsing, otherwise fallback to defaultDate
            if (isNaN(dateA.getTime())) {
              dateA.setTime(defaultDate.getTime());
            }
            if (isNaN(dateB.getTime())) {
              dateB.setTime(defaultDate.getTime());
            }

            // Compare the full dates directly (ascending or descending will be handled by react-table)
            return dateA.getTime() - dateB.getTime();
          },
        },
                 {
          key: "pod_name",
          name: "Pod Name",
          id: "pod_name",
          header: "Pod Name",
          accessorKey: "pod_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
       cell: ({ row }: any) => {
  const original = row.original;
  const members = original?.pod_members?.map(
    (it: any) => `${it.first_name} ${it.last_name}`
  );
  const hasGoal = !!original.goal_id;
  const isUpdatingPod = updatingPodDefectId === String(original.id);

  // goal exist -> sirf text dikhao
  if (hasGoal) {
    return (
      <div className="flex items-center gap-[8px] theme_btn_item">
        <span title={members}>{original.pod_name}</span>
      </div>
    );
  }

  // goal nahi -> dropdown dikhao, jisse pod change ho sake
  return (
    <div
      className="flex items-center gap-[8px] theme_btn_item dropdown-dark-input relative"
      style={{ minWidth: 150 }}
    >
      <SearchableInputsDropdown
        dontselectlastValue={true}
        label=""
        options={(allPodsData ?? [])
          .filter((p: any) => p.pod_name !== "All Pods")
          .map((p: any) => ({ key: String(p.pod_id), name: p.pod_name }))}
        placeHolder={original.pod_name || "Select pod"}
        onSelect={(selectedKey: any) => {
          if (isUpdatingPod) return;
          handleUpdatePod(original, selectedKey);
        }}
      />
      {isUpdatingPod && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/70 dark:bg-gray-800/70 rounded">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600" />
        </div>
      )}
    </div>
  );}
        },

        {
          key: "screen_name",
          name: "Generated Error Name",
          id: "screen_name",
          header: "Generated Error Name",
          accessorKey: "screen_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
     
        {
          key: "severity",
          name: "Severity",
          id: "severity",
          header: "Severity",
          accessorKey: "severity",
          enableSorting: true,
        },
        {
          key: "action",
          name: "Action",
          id: "action",
          header: "Action",
          accessorKey: "action",
          hideSearch: true,
          cell: ({ row }: any) => {
            const goalExist = row.original.is_goal_exist;
            const isCreating = autoCreatingDefectId === String(row.original.id);
            const isTemplateGoal = row.original.pod_goal_id
            return (
              <div className="flex items-center gap-[8px] theme_btn_item">
                {isCreating ? (
                  <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600" />
                    <span>Creating…</span>
                  </div>
                ) : (
                  <InputsDropdown
                    label=""
                    options={isTemplateGoal ? getDefectActionOptionsGoalExistPodTemplate  :
                      goalExist ? getDefectActionOptionsGoalExist :
                     getDefectActionOptions
                    }
                    placeHolder={
                      row.original.action_type
                        ? row.original.action_type
                        : "Select action"
                    }
                    onSelect={(selectedOption: any) => {
                      const action = selectedOption;
                      if (action === "Resolve") {
                        setDefectResolveRow(row.original);
                      }
                      // else if (isTemplateGoal) {
                      //   navigate("/edit_goal_from_template", {
                      //     state: {
                      //       goalID: row.original.pod_goal_id,
                      //       projectName: row.original.project_name,
                      //     },
                      //   });
                      // }
                       else if (goalExist) {
                        navigate("/goal_view", {
                          state: {
                            goalID: row.original.goal_id,
                            projectName: row.original.project_name,
                          },
                        });
                      } else if (action === "Bug") {
                        handleCreatePodBugGoal(row.original);
                      } else if (action === "Enhancement") {
                        handleUpdateEnhancementDefect(row.original)
                        // handleCreatePodEnhancementGoal(row.original);
                      } else if (action === "Training Issue") {
                       setSelectedTrainingIssueRow(row.original);
                        setTrainingIssuePopupOpen(true);
                      } else if (action === "Follow-up") {
                        handleAutoCreateFollowupGoal(row.original);
                      } else {
                        navigate("/add_defect_task", {
                          state: {
                            defectID: row.original.id,
                            action: action,
                            reporter_name: row.original.reporter_name,
                            screen_name: row.original.screen_name,
                            agency_name: row.original.agency_name,
                            action_type: row.original.action_type,
                            description: row.original.description,
                            screen_members: row.original.screen_members,
                            fromPodName: row.original.pod_name,
                          },
                        });
                      }
                    }}
                  />
                )}
              </div>
            );
          },
        },
      ];
    } else if (label === "Upcoming Leave" || label === "Today's Leave") {
      return [
       
        {
          key: "employee_name",
          name: "Employee Name",
          id: "employee_name",
          header: "Employee Name",
          accessorKey: "employee_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "leave_type",
          name: "Leave Type",
          id: "leave_type",
          header: "Leave Type",
          accessorKey: "leave_type",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "leave_reason",
          name: "Reason",
          id: "leave_reason",
          header: "Reason",
          accessorKey: "leave_reason",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "leave_date",
          name: "Date",
          id: "leave_date",
          header: "Date",
          accessorKey: "leave_date",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any) => {
            const startDateA = rowA?.getValue("leave_date");
            const startDateB = rowB?.getValue("leave_date");

            // If a start_date is missing (null or undefined), treat it as the latest date.
            // You can also treat missing dates as the earliest date by using `new Date(0)` instead of `new Date()`
            const defaultDate = new Date(0); // You can change this to `new Date()` if you want it sorted to the end.

            const dateA = startDateA
              ? parse(startDateA, "MM-dd-yyyy", new Date())
              : defaultDate;
            const dateB = startDateB
              ? parse(startDateB, "MM-dd-yyyy", new Date())
              : defaultDate;

            // Ensure valid date parsing, otherwise fallback to defaultDate
            if (isNaN(dateA.getTime())) {
              dateA.setTime(defaultDate.getTime());
            }
            if (isNaN(dateB.getTime())) {
              dateB.setTime(defaultDate.getTime());
            }

            // Compare the full dates directly (ascending or descending will be handled by react-table)
            return dateA.getTime() - dateB.getTime();
          },
        },
        {
          key: "status",
          name: "Status",
          id: "status",
          header: "Status",
          accessorKey: "status",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        // {
        //     key: "action",
        //     name: "Action",
        //     id: "action",
        //     header: "Action",
        //     accessorKey: "action",
        //     hideSearch: true,
        //     cell: ({ row }: any) => {
        //         const original = row.original;

        //         return (
        //             <div className="flex items-center gap-[8px]  theme_btn_item">
        //                 <button
        //                     className="dash-action-link cursor-pointer"
        //                     onClick={() => {
        //                         navigate("/task_detail", {
        //                             state: {
        //                                 taskId: row.original.taskID,
        //                             }
        //                         })
        //                     }}
        //                 >
        //                     <span className="text-sm dark:text-white">View Task</span>
        //                 </button>
        //             </div>
        //         );
        //     },
        // },
      ];
    } else if (label === "Breaks") {
      return [
       
        {
          key: "employee_name",
          name: "Employee Name",
          id: "employee_name",
          header: "Employee Name",
          accessorKey: "employee_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "start_time",
          name: "Start Time",
          id: "start_time",
          header: "Start Time",
          accessorKey: "start_time",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any) => {
            const startDateA = rowA?.getValue("start_time");
            const startDateB = rowB?.getValue("start_time");

            // If a start_date is missing (null or undefined), treat it as the latest date.
            // You can also treat missing dates as the earliest date by using `new Date(0)` instead of `new Date()`
            const defaultDate = new Date(0); // You can change this to `new Date()` if you want it sorted to the end.

            const dateA = startDateA
              ? parse(startDateA, "MM-dd-yyyy", new Date())
              : defaultDate;
            const dateB = startDateB
              ? parse(startDateB, "MM-dd-yyyy", new Date())
              : defaultDate;

            // Ensure valid date parsing, otherwise fallback to defaultDate
            if (isNaN(dateA.getTime())) {
              dateA.setTime(defaultDate.getTime());
            }
            if (isNaN(dateB.getTime())) {
              dateB.setTime(defaultDate.getTime());
            }

            // Compare the full dates directly (ascending or descending will be handled by react-table)
            return dateA.getTime() - dateB.getTime();
          },
        },
        // {
        //     key: "status",
        //     name: "Status",
        //     id: "status",
        //     header: "Status",
        //     accessorKey: "status",
        //     enableSorting: true,
        //     sortingFn: (rowA: any, rowB: any, columnId: any) => {
        //         const valueA = String(
        //             rowA.getValue(columnId) || ""
        //         ).toLowerCase();
        //         const valueB = String(
        //             rowB.getValue(columnId) || ""
        //         ).toLowerCase();
        //         return valueA.localeCompare(valueB);
        //     },
        // },
        // {
        //     key: "action",
        //     name: "Action",
        //     id: "action",
        //     header: "Action",
        //     accessorKey: "action",
        //     hideSearch: true,
        //     cell: ({ row }: any) => {
        //         const original = row.original;

        //         return (
        //             <div className="flex items-center gap-[8px]  theme_btn_item">
        //                 <button
        //                     className="dash-action-link cursor-pointer"
        //                     onClick={() => {
        //                         navigate("/task_detail", {
        //                             state: {
        //                                 taskId: row.original.taskID,
        //                             }
        //                         })
        //                     }}
        //                 >
        //                     <span className="text-sm dark:text-white">View Task</span>
        //                 </button>
        //             </div>
        //         );
        //     },
        // },
      ];
    } else if (label === "Upcoming Features") {
      return [
       
        {
          key: "goal_name",
          name: "Goal",
          id: "goal_name",
          header: "Goal",
          accessorKey: "goal_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "project_name",
          name: "Project",
          id: "project_name",
          header: "Project",
          accessorKey: "project_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "release_date",
          name: "Release Date",
          id: "release_date",
          header: "Release Date",
          accessorKey: "release_date",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any) => {
            const startDateA = rowA?.getValue("release_date");
            const startDateB = rowB?.getValue("release_date");

            // If a start_date is missing (null or undefined), treat it as the latest date.
            // You can also treat missing dates as the earliest date by using `new Date(0)` instead of `new Date()`
            const defaultDate = new Date(0); // You can change this to `new Date()` if you want it sorted to the end.

            const dateA = startDateA
              ? parse(startDateA, "MM-dd-yyyy", new Date())
              : defaultDate;
            const dateB = startDateB
              ? parse(startDateB, "MM-dd-yyyy", new Date())
              : defaultDate;

            // Ensure valid date parsing, otherwise fallback to defaultDate
            if (isNaN(dateA.getTime())) {
              dateA.setTime(defaultDate.getTime());
            }
            if (isNaN(dateB.getTime())) {
              dateB.setTime(defaultDate.getTime());
            }

            // Compare the full dates directly (ascending or descending will be handled by react-table)
            return dateA.getTime() - dateB.getTime();
          },
        },
        {
          key: "status",
          name: "Status",
          id: "status",
          header: "Status",
          accessorKey: "status",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "action",
          name: "Action",
          id: "action",
          header: "Action",
          accessorKey: "action",
          hideSearch: true,
          cell: ({ row }: any) => {
            const original = row.original;
            const projectName = original?.project_name;
            const id = original?.goal_id;

            return (
              <>
                <div className="flex items-center gap-[8px]  theme_btn_item">
                  <button
                    title="View Goal"
                    className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                    onClick={() => {
                      navigate("/goal_view", {
                        state: {
                          goalID: id,
                          projectName: projectName,
                        },
                      });
                    }}
                  >
                    <span className="text-sm dark:text-white"> <img src={viewIcon} className=" w-5 h-6 object-contain" alt="" /></span> 
                    {/* <span className="text-sm dark:text-white">View Goal</span> */}
                  </button>
                </div>
              </>
            );
          },
        },
      ];
    } else if (label === "Bugs") {
      return [
               
        {
          key: "reporter_name",
          name: "Reporter Name",
          id: "reporter_name",
          header: "Reporter Name",
          accessorKey: "reporter_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
          cell: ({ row }: any) => {
            return (
              <div className="flex items-center gap-[8px]  theme_btn_item">
                <span
                  className="defact-click-item cursor-pointer"
                  onClick={() => setOpenDefectEmail(row.original.id)}
                >
                  {row.original.reporter_name}
                </span>
              </div>
            );
          },
        },
        {
          key: "agency_name",
          name: "Business Name",
          id: "agency_name",
          header: "Business Name",
          accessorKey: "agency_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "created_on",
          name: "Reported Date",
          id: "created_on",
          header: "Reported Date",
          accessorKey: "created_on",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any) => {
            const startDateA = rowA?.getValue("created_on");
            const startDateB = rowB?.getValue("created_on");

            // If a start_date is missing (null or undefined), treat it as the latest date.
            // You can also treat missing dates as the earliest date by using `new Date(0)` instead of `new Date()`
            const defaultDate = new Date(0); // You can change this to `new Date()` if you want it sorted to the end.

            const dateA = startDateA
              ? parse(startDateA, "MM-dd-yyyy", new Date())
              : defaultDate;
            const dateB = startDateB
              ? parse(startDateB, "MM-dd-yyyy", new Date())
              : defaultDate;

            // Ensure valid date parsing, otherwise fallback to defaultDate
            if (isNaN(dateA.getTime())) {
              dateA.setTime(defaultDate.getTime());
            }
            if (isNaN(dateB.getTime())) {
              dateB.setTime(defaultDate.getTime());
            }

            // Compare the full dates directly (ascending or descending will be handled by react-table)
            return dateA.getTime() - dateB.getTime();
          },
        },

                 {
          key: "pod_name",
          name: "Pod Name",
          id: "pod_name",
          header: "Pod Name",
          accessorKey: "pod_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB); },
  cell: ({ row }: any) => {
  const original = row.original;
  const members = original?.pod_members?.map(
    (it: any) => `${it.first_name} ${it.last_name}`
  );
  const hasGoal = !!original.goal_id;
  const isUpdatingPod = updatingPodDefectId === String(original.id);

  // goal exist -> sirf text dikhao
  if (hasGoal || bugStatusFilter == "Customer Approval" || bugStatusFilter == "Closed") {
    return (
      <div className="flex items-center gap-[8px] theme_btn_item">
        <span title={members}>{original.pod_name}</span>
      </div>
    );
  }

  // goal nahi -> dropdown dikhao, jisse pod change ho sake
  return (
    <div
      className="flex items-center gap-[8px] theme_btn_item dropdown-dark-input relative"
      style={{ minWidth: 150 }}
    >
      <SearchableInputsDropdown
dontselectlastValue={true}
        label=""
        options={(allPodsData ?? [])
          .filter((p: any) => p.pod_name !== "All Pods")
          .map((p: any) => ({ key: String(p.pod_id), name: p.pod_name }))}
        placeHolder={original.pod_name || "Select pod"}
        onSelect={(selectedKey: any) => {
          if (isUpdatingPod) return;
          handleUpdatePod(original, selectedKey);
        }}
      />
      {isUpdatingPod && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/70 dark:bg-gray-800/70 rounded">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600" />
        </div>
      )}
    </div>
  );
          },
        },

        {
          key: "screen_name",
          name: "Generated Error Name",
          id: "screen_name",
          header: "Generated Error Name",
          accessorKey: "screen_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "severity",
          name: "Severity",
          id: "severity",
          header: "Severity",
          accessorKey: "severity",
          enableSorting: true,
        },
        {
          key: "goal_status",
          name: "Status",
          id: "goal_status",
          header: "Status",
          accessorKey: "goal_status",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
               cell: ({ row }: any) => {
                 const is_resolved = row.original.is_resolved;
                 return (
                  <span>{is_resolved ?  "Completed" : row.original.goal_status}</span>
                 )
               }
        },
        {
          key: "action",
          name: "Action",
          id: "action",
          header: "Action",
          accessorKey: "action",
          hideSearch: true,
          cell: ({ row }: any) => {
            const is_resolved = row.original.is_resolved;
            const is_approved = row.original.is_approved;

             const goalExist = row.original.is_goal_exist;
              const isCreating = autoCreatingDefectId === String(row.original.id);
              
            return (
              is_resolved && !is_approved ?
              <div className="flex items-center gap-[8px]  theme_btn_item">
                {
                  goalExist &&          <button
                 title="View"
                  className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                  onClick={() => {
                    navigate("/goal_view", {
                      state: {
                        goalID: row.original.goal_id,
                        projectName: row.original.project_name,
                      },
                    });
                  }}
                >
                  <span className="text-sm dark:text-white"> <img src={viewIcon} className=" w-5 h-6 object-contain" alt="" /></span> 
                </button>
                }
       
                <button
                    title="Resolve"
                      className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                      onClick={() => setBugResolveDefect(row.original)}
                    >
                      <span className="text-sm dark:text-white"> <img src={resolvedIcon} className=" w-4 h-6 object-contain" alt="" /></span> 
                      </button>
     
                  <button
                    className="dash-action-link cursor-pointer"
                    onClick={() => setViewNotesDefect(row.original)}
                  >
                    <span className="text-sm dark:text-white"> View Notes</span>
                  </button>
        
              </div> 
              :
              goalExist ?
              <div className="flex items-center gap-[8px]  theme_btn_item">
                <button
                 title="View"
                  className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                  onClick={() => {
                    navigate("/goal_view", {
                      state: {
                        goalID: row.original.goal_id,
                        projectName: row.original.project_name,
                      },
                    });
                  }}
                >

                  <span className="text-sm dark:text-white"> <img src={viewIcon} className=" w-5 h-6 object-contain" alt="" /></span> 
                </button>
                {
                  !is_resolved && canShowResolveForOpenGoal(row.original, bugStatusFilter) &&  (
                    <button
                    title="Resolve"
                      className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                      onClick={() => setBugResolveDefect(row.original)}
                    >
                      <span className="text-sm dark:text-white"> <img src={resolvedIcon} className=" w-4 h-6 object-contain" alt="" /></span> 
                      </button>
                  )
                }
                {!is_resolved && (
                  <button
                    title="Reassign"
                    className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                    onClick={() => {
                      const pod = allPodsData?.find((p: any) => p.pod_name === row.original.pod_name);
                      setReassignPod(pod || null);
                      const at = row.original.action_type || "";
                      setReassignActionType(at === "Follow up" || at === "Follow-up" ? "Follow Up" : at);
                      setReassignAlert(row.original);
                    }}
                  >
                       <span className="text-sm dark:text-white"> <img src={resssignIcon} className=" w-4 h-6 object-contain" alt="" /></span> 
                  </button>
                )}
                {is_resolved && (
                  <button
                    className="dash-action-link cursor-pointer"
                    onClick={() => setViewNotesDefect(row.original)}
                  >
                    <span className="text-sm dark:text-white"> View Notes</span>
                  </button>
                )}
              </div> : is_resolved ?  <div className="flex items-center gap-[8px]  theme_btn_item">
                <button
                title="View"
                  className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                  onClick={() => {
                    navigate("/goal_view", {
                      state: {
                        goalID: row.original.goal_id,
                        projectName: row.original.project_name,
                      },
                    });
                  }}
                >
                  <span className="text-sm dark:text-white"> <img src={viewIcon} className=" w-5 h-6 object-contain" alt="" /></span> 
                  {/* <span className="text-sm dark:text-white"> View</span> */}
                </button>
                <button
                  className="dash-action-link cursor-pointer"
                  onClick={() => setViewNotesDefect(row.original)}
                >
                  <span className="text-sm dark:text-white"> View Notes</span>
                </button>
              </div> :  <div className="flex items-center gap-[8px] theme_btn_item">
                {isCreating ? (
                  <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600" />
                    <span>Creating…</span>
                  </div>
                ) : (
                  <InputsDropdown
                    label=""
                    options={
                      goalExist ? getDefectActionOptionsGoalExist :
                     getDefectActionOptions
                    }
                    placeHolder={
                      row.original.action_type
                        ? row.original.action_type
                        : "Select action"
                    }
                    onSelect={(selectedOption: any) => {
                      const action = selectedOption;
                      if (action === "Resolve") {
                        setDefectResolveRow(row.original);
                      } else if (goalExist) {
                        navigate("/goal_view", {
                          state: {
                            goalID: row.original.goal_id,
                            projectName: row.original.project_name,
                          },
                        });
                      } else if (action === "Bug") {
                        handleCreatePodBugGoal(row.original);
                      } else if (action === "Enhancement") {
                        // handleCreatePodEnhancementGoal(row.original);
                          handleUpdateEnhancementDefect(row.original)
                      } else if (action === "Training Issue") {
                       setSelectedTrainingIssueRow(row.original);
                        setTrainingIssuePopupOpen(true);
                      } else if (action === "Follow-up") {
                        handleAutoCreateFollowupGoal(row.original);
                      } else {
                        navigate("/add_defect_task", {
                          state: {
                            defectID: row.original.id,
                            action: action,
                            reporter_name: row.original.reporter_name,
                            screen_name: row.original.screen_name,
                            agency_name: row.original.agency_name,
                            action_type: row.original.action_type,
                            description: row.original.description,
                            screen_members: row.original.screen_members,
                            fromPodName: row.original.pod_name,
                          },
                        });
                      }
                    }}
                  />
                )}
              </div>
            );
          },
        },
      ];
    } else if (label === "Enhancements") {
      return [
               
        {
          key: "reporter_name",
          name: "Reporter Name",
          id: "reporter_name",
          header: "Reporter Name",
          accessorKey: "reporter_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
          cell: ({ row }: any) => {
            return (
              <div className="flex items-center gap-[8px]  theme_btn_item">
                <span
                  className="defact-click-item cursor-pointer"
                  onClick={() => setOpenDefectEmail(row.original.id)}
                >
                  {row.original.reporter_name}
                </span>
              </div>
            );
          },
        },
        {
          key: "agency_name",
          name: "Business Name",
          id: "agency_name",
          header: "Business Name",
          accessorKey: "agency_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },

                 {
          key: "pod_name",
          name: "Pod Name",
          id: "pod_name",
          header: "Pod Name",
          accessorKey: "pod_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB); },
cell: ({ row }: any) => {
  const original = row.original;
  const members = original?.pod_members?.map(
    (it: any) => `${it.first_name} ${it.last_name}`
  );
  const hasGoal = !!original.goal_id;
  const isUpdatingPod = updatingPodDefectId === String(original.id);

  // goal exist -> sirf text dikhao
  if (hasGoal || enhancmentStatusFilter == "Customer Approval" || enhancmentStatusFilter == "Closed") {
    return (
      <div className="flex items-center gap-[8px] theme_btn_item">
        <span title={members}>{original.pod_name}</span>
      </div>
    );
  }

  // goal nahi -> dropdown dikhao, jisse pod change ho sake
  return (
    <div
      className="flex items-center gap-[8px] theme_btn_item dropdown-dark-input relative"
      style={{ minWidth: 150 }}
    >
      <SearchableInputsDropdown
dontselectlastValue={true}
        label=""
        options={(allPodsData ?? [])
          .filter((p: any) => p.pod_name !== "All Pods")
          .map((p: any) => ({ key: String(p.pod_id), name: p.pod_name }))}
        placeHolder={original.pod_name || "Select pod"}
        onSelect={(selectedKey: any) => {
          if (isUpdatingPod) return;
          handleUpdatePod(original, selectedKey);
        }}
      />
      {isUpdatingPod && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/70 dark:bg-gray-800/70 rounded">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600" />
        </div>
      )}
    </div>
  );
          },
        },
        {
          key: "created_on",
          name: "Reported Date",
          id: "created_on",
          header: "Reported Date",
          accessorKey: "created_on",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any) => {
            const startDateA = rowA?.getValue("created_on");
            const startDateB = rowB?.getValue("created_on");

            // If a start_date is missing (null or undefined), treat it as the latest date.
            // You can also treat missing dates as the earliest date by using `new Date(0)` instead of `new Date()`
            const defaultDate = new Date(0); // You can change this to `new Date()` if you want it sorted to the end.

            const dateA = startDateA
              ? parse(startDateA, "MM-dd-yyyy", new Date())
              : defaultDate;
            const dateB = startDateB
              ? parse(startDateB, "MM-dd-yyyy", new Date())
              : defaultDate;

            // Ensure valid date parsing, otherwise fallback to defaultDate
            if (isNaN(dateA.getTime())) {
              dateA.setTime(defaultDate.getTime());
            }
            if (isNaN(dateB.getTime())) {
              dateB.setTime(defaultDate.getTime());
            }

            // Compare the full dates directly (ascending or descending will be handled by react-table)
            return dateA.getTime() - dateB.getTime();
          },
        },
        {
          key: "severity",
          name: "Severity",
          id: "severity",
          header: "Severity",
          accessorKey: "severity",
          enableSorting: true,
        },
        {
          key: "goal_status",
          name: "Status",
          id: "goal_status",
          header: "Status",
          accessorKey: "goal_status",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
                         cell: ({ row }: any) => {
                 const is_resolved = row.original.is_resolved;
                 return (
                  <span>{is_resolved ?  "Completed" : row.original.goal_status}</span>
                 )
               }
        },
        {
          key: "action",
          name: "Action",
          id: "action",
          header: "Action",
          accessorKey: "action",
          hideSearch: true,
          cell: ({ row }: any) => {
            const is_resolved = row.original.is_resolved;
            const is_approved = row.original.is_approved;

                         const goalExist = row.original.is_goal_exist;
                         const isCreating = autoCreatingDefectId === String(row.original.id);
            return (
                     is_resolved && !is_approved ?
              <div className="flex items-center gap-[8px]  theme_btn_item">
                   {
                  goalExist &&      <button
                 title="View"
                  className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                  onClick={() => {
                    navigate("/goal_view", {
                      state: {
                        goalID: row.original.goal_id,
                        projectName: row.original.project_name,
                      },
                    });
                  }}
                >
                  <span className="text-sm dark:text-white"> <img src={viewIcon} className=" w-5 h-6 object-contain" alt="" /></span> 
                </button>
                         }
       
                <button
                    title="Resolve"
                      className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                      onClick={() => setEnhancementResolveRow(row.original)}
                    >
                      <span className="text-sm dark:text-white"> <img src={resolvedIcon} className=" w-4 h-6 object-contain" alt="" /></span> 
                      </button>
     
                  <button
                    className="dash-action-link cursor-pointer"
                    onClick={() => setViewNotesDefect(row.original)}
                  >
                    <span className="text-sm dark:text-white"> View Notes</span>
                  </button>
        
              </div> 
              :
               goalExist ?
              <div className="flex items-center gap-[8px]  theme_btn_item">
                <button
                   title="View"
                  className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                  onClick={() => {
                    navigate("/goal_view", {
                      state: {
                        goalID: row.original.goal_id,
                        projectName: row.original.project_name,
                      },
                    });
                  }}
                >
                   <span className="text-sm dark:text-white"> <img src={viewIcon} className=" w-5 h-6 object-contain" alt="" /></span> 
                  {/* <span className="text-sm dark:text-white"> View</span> */}
                </button>
                {!is_resolved && canShowResolveForOpenGoal(row.original, enhancmentStatusFilter) && (
                  <button
                    title="Resolve"
                    className=" dash-action-link cursor-pointer viewbtn-tooltip-item"
                    onClick={() => { setEnhancementResolveRow(row.original); }}
                  >
                      <span className="text-sm dark:text-white"> <img src={resolvedIcon} className=" w-4 h-6 object-contain" alt="" /></span> 
                    {/* <span className="text-sm dark:text-white"> Resolve</span> */}
                  </button>
                )}
                {!is_resolved && (
                  <button
                  title="Reassign"
                    className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                    onClick={() => {
                      const pod = allPodsData?.find((p: any) => p.pod_name === row.original.pod_name);
                      setReassignPod(pod || null);
                      const at = row.original.action_type || "";
                      setReassignActionType(at === "Follow up" || at === "Follow-up" ? "Follow Up" : at);
                      setReassignAlert(row.original);
                    }}
                  >
                    <span className="text-sm dark:text-white"> <img src={resssignIcon} className=" w-4 h-6 object-contain" alt="" /></span> 
                    {/* <span className="text-sm dark:text-white"> Reassign</span> */}
                  </button>
                )}
                {is_resolved && (
                  <button
                    className="dash-action-link cursor-pointer"
                    onClick={() => setViewNotesDefect(row.original)}
                  >
                    <span className="text-sm dark:text-white"> View Notes</span>
                  </button>
                )}
              </div>
              : is_resolved ?  <div className="flex items-center gap-[8px]  theme_btn_item">
                <button
                  className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                  onClick={() => {
                    navigate("/goal_view", {
                      state: {
                        goalID: row.original.goal_id,
                        projectName: row.original.project_name,
                      },
                    });
                  }}
                >
                  <span className="text-sm dark:text-white"> <img src={viewIcon} className=" w-5 h-6 object-contain" alt="" /></span> 
                  {/* <span className="text-sm dark:text-white"> View</span> */}
                </button>
                <button
                  className="dash-action-link cursor-pointer"
                  onClick={() => setViewNotesDefect(row.original)}
                >
                  <span className="text-sm dark:text-white"> View Notes</span>
                </button>
              </div> :
               <div className="flex items-center gap-[8px] theme_btn_item">
                {isCreating ? (
                  <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600" />
                    <span>Creating…</span>
                  </div>
                ) : (
                  <InputsDropdown
                    label=""
                    options={
                      goalExist ? getDefectActionOptionsGoalExist :
                     getDefectActionOptions
                    }
                    placeHolder={
                      row.original.action_type
                        ? row.original.action_type
                        : "Select action"
                    }
                    onSelect={(selectedOption: any) => {
                      const action = selectedOption;
                      if (action === "Resolve") {
                        setDefectResolveRow(row.original);
                      } else if (goalExist) {
                        navigate("/goal_view", {
                          state: {
                            goalID: row.original.goal_id,
                            projectName: row.original.project_name,
                          },
                        });
                      } else if (action === "Bug") {
                        handleCreatePodBugGoal(row.original);
                      } else if (action === "Enhancement") {
                        handleCreatePodEnhancementGoal(row.original);
                      } else if (action === "Training Issue") {
                       setSelectedTrainingIssueRow(row.original);
                      setTrainingIssuePopupOpen(true);
                      } else if (action === "Follow-up") {
                        handleAutoCreateFollowupGoal(row.original);
                      } else {
                        navigate("/add_defect_task", {
                          state: {
                            defectID: row.original.id,
                            action: action,
                            reporter_name: row.original.reporter_name,
                            screen_name: row.original.screen_name,
                            agency_name: row.original.agency_name,
                            action_type: row.original.action_type,
                            description: row.original.description,
                            screen_members: row.original.screen_members,
                            fromPodName: row.original.pod_name,
                          },
                        });
                      }
                    }}
                  />
                )}
              </div>
            );
          },
        },
      ];
    } else if (label === "Follow Up") {
      return [
               
        {
          key: "reporter_name",
          name: "Reporter Name",
          id: "reporter_name",
          header: "Reporter Name",
          accessorKey: "reporter_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
          cell: ({ row }: any) => {
            return (
              <div className="flex items-center gap-[8px]  theme_btn_item">
                <span
                  className="defact-click-item cursor-pointer"
                  onClick={() => setOpenDefectEmail(row.original.id)}
                >
                  {row.original.reporter_name}
                </span>
              </div>
            );
          },
        },
        {
          key: "agency_name",
          name: "Business Name",
          id: "agency_name",
          header: "Business Name",
          accessorKey: "agency_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },

                 {
          key: "pod_name",
          name: "Pod Name",
          id: "pod_name",
          header: "Pod Name",
          accessorKey: "pod_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);},
 cell: ({ row }: any) => {
  const original = row.original;
  const members = original?.pod_members?.map(
    (it: any) => `${it.first_name} ${it.last_name}`
  );
  const hasGoal = !!original.goal_id;
  const isUpdatingPod = updatingPodDefectId === String(original.id);

  // goal exist -> sirf text dikhao
  if (hasGoal || followUpStatusFilter == "Customer Approval" ||  followUpStatusFilter == "Closed" ) {
    return (
      <div className="flex items-center gap-[8px] theme_btn_item">
        <span title={members}>{original.pod_name}</span>
      </div>
    );
  }

  // goal nahi -> dropdown dikhao, jisse pod change ho sake
  return (
    <div
      className="flex items-center gap-[8px] theme_btn_item dropdown-dark-input relative"
      style={{ minWidth: 150 }}
    >
      <SearchableInputsDropdown
dontselectlastValue={true}
        label=""
        options={(allPodsData ?? [])
          .filter((p: any) => p.pod_name !== "All Pods")
          .map((p: any) => ({ key: String(p.pod_id), name: p.pod_name }))}
        placeHolder={original.pod_name || "Select pod"}
        onSelect={(selectedKey: any) => {
          if (isUpdatingPod) return;
          handleUpdatePod(original, selectedKey);
        }}
      />
      {isUpdatingPod && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/70 dark:bg-gray-800/70 rounded">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600" />
        </div>
      )}
    </div>
  );
          },
        },
        {
          key: "created_on",
          name: "Reported Date",
          id: "created_on",
          header: "Reported Date",
          accessorKey: "created_on",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any) => {
            const startDateA = rowA?.getValue("created_on");
            const startDateB = rowB?.getValue("created_on");

            // If a start_date is missing (null or undefined), treat it as the latest date.
            // You can also treat missing dates as the earliest date by using `new Date(0)` instead of `new Date()`
            const defaultDate = new Date(0); // You can change this to `new Date()` if you want it sorted to the end.

            const dateA = startDateA
              ? parse(startDateA, "MM-dd-yyyy", new Date())
              : defaultDate;
            const dateB = startDateB
              ? parse(startDateB, "MM-dd-yyyy", new Date())
              : defaultDate;

            // Ensure valid date parsing, otherwise fallback to defaultDate
            if (isNaN(dateA.getTime())) {
              dateA.setTime(defaultDate.getTime());
            }
            if (isNaN(dateB.getTime())) {
              dateB.setTime(defaultDate.getTime());
            }

            // Compare the full dates directly (ascending or descending will be handled by react-table)
            return dateA.getTime() - dateB.getTime();
          },
        },
        {
          key: "severity",
          name: "Severity",
          id: "severity",
          header: "Severity",
          accessorKey: "severity",
          enableSorting: true,
        },
        {
          key: "goal_status",
          name: "Status",
          id: "goal_status",
          header: "Status",
          accessorKey: "goal_status",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
                         cell: ({ row }: any) => {
                 const is_resolved = row.original.is_resolved;
                 return (
                  <span>{is_resolved ?  "Completed" : row.original.goal_status}</span>
                 )
               }
        },
        {
          key: "action",
          name: "Action",
          id: "action",
          header: "Action",
          accessorKey: "action",
          hideSearch: true,
          cell: ({ row }: any) => {
            const is_resolved = row.original.is_resolved;
                         const goalExist = row.original.is_goal_exist;
                         const isCreating = autoCreatingDefectId === String(row.original.id);
                                     const is_approved = row.original.is_approved;
            return (
                 is_resolved && !is_approved ?
              <div className="flex items-center gap-[8px]  theme_btn_item">
              {
                      goalExist &&       <button
                 title="View"
                  className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                  onClick={() => {
                    navigate("/goal_view", {
                      state: {
                        goalID: row.original.goal_id,
                        projectName: row.original.project_name,
                      },
                    });
                  }}
                >
                  <span className="text-sm dark:text-white"> <img src={viewIcon} className=" w-5 h-6 object-contain" alt="" /></span> 
                </button>    
              } 
                <button
                    title="Resolve"
                      className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                      onClick={() => setDefectResolveRow(row.original)}
                    >
                      <span className="text-sm dark:text-white"> <img src={resolvedIcon} className=" w-4 h-6 object-contain" alt="" /></span> 
                      </button>
     
                  <button
                    className="dash-action-link cursor-pointer"
                    onClick={() => setViewNotesDefect(row.original)}
                  >
                    <span className="text-sm dark:text-white"> View Notes</span>
                  </button>
        
              </div> 
              :
              goalExist ?
              <div className="flex items-center gap-[8px]  theme_btn_item">
                <button
                title="View"
                  className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                  onClick={() => {
                    navigate("/goal_view", {
                      state: {
                        goalID: row.original.goal_id,
                        projectName: row.original.project_name,
                      },
                    });
                  }}
                >
                  <span className="text-sm dark:text-white"> <img src={viewIcon} className=" w-5 h-6 object-contain" alt="" /></span> 
                  {/* <span className="text-sm dark:text-white"> View</span> */}
                </button>
                {!is_resolved && (
                  <button
                    className=" dash-action-link cursor-pointer viewbtn-tooltip-item"
                    onClick={() => { setDefectResolveRow(row.original); }}
                    title="Resolve"
                  >
                    <span className="text-sm dark:text-white"> <img src={resolvedIcon} className=" w-4 h-6 object-contain" alt="" /></span> 
                    {/* <span className="text-sm dark:text-white"> Resolve</span> */}
                  </button>
                )}
                {!is_resolved && (
                  <button
                  title="Reassign"
                    className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                    onClick={() => {
                      const pod = allPodsData?.find((p: any) => p.pod_name === row.original.pod_name);
                      setReassignPod(pod || null);
                      const at = row.original.action_type || "";
                      setReassignActionType(at === "Follow up" || at === "Follow-up" ? "Follow Up" : at);
                      setReassignAlert(row.original);
                    }}
                  >
                     <span className="text-sm dark:text-white"> <img src={resssignIcon} className=" w-4 h-6 object-contain" alt="" /></span> 
                    {/* <span className="text-sm dark:text-white"> Reassign</span> */}
                  </button>
                )}
                {is_resolved && (
                  <button
                    className="dash-action-link cursor-pointer"
                    onClick={() => setViewNotesDefect(row.original)}
                  >
                    <span className="text-sm dark:text-white"> View Notes</span>
                  </button>
                )}
              </div> : is_resolved ?   <div className="flex items-center gap-[8px]  theme_btn_item">
                <button
                title="View"
                  className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                  onClick={() => {
                    navigate("/goal_view", {
                      state: {
                        goalID: row.original.goal_id,
                        projectName: row.original.project_name,
                      },
                    });
                  }}
                >
                  <span className="text-sm dark:text-white"> <img src={viewIcon} className=" w-5 h-6 object-contain" alt="" /></span> 
                  {/* <span className="text-sm dark:text-white"> View</span> */}
                </button>
                <button
                  className="dash-action-link cursor-pointer"
                  onClick={() => setViewNotesDefect(row.original)}
                >
                  <span className="text-sm dark:text-white"> View Notes</span>
                </button>
              </div> :  <div className="flex items-center gap-[8px] theme_btn_item">
                {isCreating ? (
                  <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600" />
                    <span>Creating…</span>
                  </div>
                ) : (
                  <InputsDropdown
                    label=""
                    options={
                      goalExist ? getDefectActionOptionsGoalExist :
                     getDefectActionOptions
                    }
                    placeHolder={
                      row.original.action_type
                        ? row.original.action_type
                        : "Select action"
                    }
                    onSelect={(selectedOption: any) => {
                      const action = selectedOption;
                      if (action === "Resolve") {
                        setDefectResolveRow(row.original);
                      } else if (goalExist) {
                        navigate("/goal_view", {
                          state: {
                            goalID: row.original.goal_id,
                            projectName: row.original.project_name,
                          },
                        });
                      } else if (action === "Bug") {
                        handleCreatePodBugGoal(row.original);
                      } else if (action === "Enhancement") {
                          handleUpdateEnhancementDefect(row.original)
                      } else if (action === "Training Issue") {
                       setSelectedTrainingIssueRow(row.original);
                        setTrainingIssuePopupOpen(true);
                      } else if (action === "Follow-up") {
                        handleAutoCreateFollowupGoal(row.original);
                      } else {
                        navigate("/add_defect_task", {
                          state: {
                            defectID: row.original.id,
                            action: action,
                            reporter_name: row.original.reporter_name,
                            screen_name: row.original.screen_name,
                            agency_name: row.original.agency_name,
                            action_type: row.original.action_type,
                            description: row.original.description,
                            screen_members: row.original.screen_members,
                            fromPodName: row.original.pod_name,
                          },
                        });
                      }
                    }}
                  />
                )}
              </div>
            );
          },
        },
      ];
    }  else if (label === "Training Issue") {
      return [
               
        {
          key: "reporter_name",
          name: "Reporter Name",
          id: "reporter_name",
          header: "Reporter Name",
          accessorKey: "reporter_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
          cell: ({ row }: any) => {
            return (
              <div className="flex items-center gap-[8px]  theme_btn_item">
                <span
                  className="defact-click-item cursor-pointer"
                  onClick={() => setOpenDefectEmail(row.original.id)}
                >
                  {row.original.reporter_name}
                </span>
              </div>
            );
          },
        },
        {
          key: "agency_name",
          name: "Business Name",
          id: "agency_name",
          header: "Business Name",
          accessorKey: "agency_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },

                 {
          key: "pod_name",
          name: "Pod Name",
          id: "pod_name",
          header: "Pod Name",
          accessorKey: "pod_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB); },
 cell: ({ row }: any) => {
  const original = row.original;
  const members = original?.pod_members?.map(
    (it: any) => `${it.first_name} ${it.last_name}`
  );
  const hasGoal = !!original.goal_id;
  const isUpdatingPod = updatingPodDefectId === String(original.id);

  // goal exist -> sirf text dikhao
  if (hasGoal || trainingStatusFilter == "Customer Approval" || trainingStatusFilter == "Closed") {
    return (
      <div className="flex items-center gap-[8px] theme_btn_item">
        <span title={members}>{original.pod_name}</span>
      </div>
    );
  }

  // goal nahi -> dropdown dikhao, jisse pod change ho sake
  return (
    <div
      className="flex items-center gap-[8px] theme_btn_item dropdown-dark-input relative"
      style={{ minWidth: 150 }}
    >
      <SearchableInputsDropdown
dontselectlastValue={true}
        label=""
        options={(allPodsData ?? [])
          .filter((p: any) => p.pod_name !== "All Pods")
          .map((p: any) => ({ key: String(p.pod_id), name: p.pod_name }))}
        placeHolder={original.pod_name || "Select pod"}
        onSelect={(selectedKey: any) => {
          if (isUpdatingPod) return;
          handleUpdatePod(original, selectedKey);
        }}
      />
      {isUpdatingPod && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/70 dark:bg-gray-800/70 rounded">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600" />
        </div>
      )}
    </div>
  );
          },
        },
        {
          key: "created_on",
          name: "Reported Date",
          id: "created_on",
          header: "Reported Date",
          accessorKey: "created_on",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any) => {
            const startDateA = rowA?.getValue("created_on");
            const startDateB = rowB?.getValue("created_on");

            // If a start_date is missing (null or undefined), treat it as the latest date.
            // You can also treat missing dates as the earliest date by using `new Date(0)` instead of `new Date()`
            const defaultDate = new Date(0); // You can change this to `new Date()` if you want it sorted to the end.

            const dateA = startDateA
              ? parse(startDateA, "MM-dd-yyyy", new Date())
              : defaultDate;
            const dateB = startDateB
              ? parse(startDateB, "MM-dd-yyyy", new Date())
              : defaultDate;

            // Ensure valid date parsing, otherwise fallback to defaultDate
            if (isNaN(dateA.getTime())) {
              dateA.setTime(defaultDate.getTime());
            }
            if (isNaN(dateB.getTime())) {
              dateB.setTime(defaultDate.getTime());
            }

            // Compare the full dates directly (ascending or descending will be handled by react-table)
            return dateA.getTime() - dateB.getTime();
          },
        },
        {
          key: "severity",
          name: "Severity",
          id: "severity",
          header: "Severity",
          accessorKey: "severity",
          enableSorting: true,
        },
        {
          key: "goal_status",
          name: "Status",
          id: "goal_status",
          header: "Status",
          accessorKey: "goal_status",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
                         cell: ({ row }: any) => {
                 const is_resolved = row.original.is_resolved;
                 return (
                  <span>{is_resolved ?  "Completed" : row.original.goal_status}</span>
                 )
               }
        },
        {
          key: "action",
          name: "Action",
          id: "action",
          header: "Action",
          accessorKey: "action",
          hideSearch: true,
          cell: ({ row }: any) => {
            const is_resolved = row.original.is_resolved;
                  const is_approved = row.original.is_approved;
              const goalExist = row.original.is_goal_exist;
                         const isCreating = autoCreatingDefectId === String(row.original.id);

            return (
                          is_resolved && !is_approved ?
              <div className="flex items-center gap-[8px]  theme_btn_item">
             {
              goalExist &&     <button
                 title="View"
                  className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                  onClick={() => {
                    navigate("/goal_view", {
                      state: {
                        goalID: row.original.goal_id,
                        projectName: row.original.project_name,
                      },
                    });
                  }}
                >
                  <span className="text-sm dark:text-white"> <img src={viewIcon} className=" w-5 h-6 object-contain" alt="" /></span> 
                </button>
             }   
         
                <button
                    title="Resolve"
                      className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                      onClick={() => setDefectResolveRow(row.original)}
                    >
                      <span className="text-sm dark:text-white"> <img src={resolvedIcon} className=" w-4 h-6 object-contain" alt="" /></span> 
                      </button>
     
                  <button
                    className="dash-action-link cursor-pointer"
                    onClick={() => setViewNotesDefect(row.original)}
                  >
                    <span className="text-sm dark:text-white"> View Notes</span>
                  </button>
        
              </div> 
              :
                 goalExist ?
              <div className="flex items-center gap-[8px]  theme_btn_item">
                <button
                title="View"
                  className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                  onClick={() => {
                    navigate("/goal_view", {
                      state: {
                        goalID: row.original.goal_id,
                        projectName: row.original.project_name,
                      },
                    });
                  }}
                >
                  <span className="text-sm dark:text-white"> <img src={viewIcon} className=" w-5 h-6 object-contain" alt="" /></span> 
                  {/* <span className="text-sm dark:text-white"> View</span> */}
                </button>
                {!is_resolved && canShowResolveForOpenGoal(row.original, trainingStatusFilter) && (
                  <button
                  title="Resolve"
                    className=" dash-action-link cursor-pointer viewbtn-tooltip-item"
                    onClick={() => { setDefectResolveRow(row.original); }}
                  >
                     <span className="text-sm dark:text-white"> <img src={resolvedIcon} className=" w-4 h-6 object-contain" alt="" /></span> 
                    {/* <span className="text-sm dark:text-white"> Resolve</span> */}
                  </button>
                )}
                {!is_resolved && (
                  <button
                    title="Reassign"
                    className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                    onClick={() => {
                      const pod = allPodsData?.find((p: any) => p.pod_name === row.original.pod_name);
                      setReassignPod(pod || null);
                      const at = row.original.action_type || "";
                      setReassignActionType(at === "Follow up" || at === "Follow-up" ? "Follow Up" : at);
                      setReassignAlert(row.original);
                    }}
                  >
                     <span className="text-sm dark:text-white"> <img src={resssignIcon} className=" w-4 h-6 object-contain" alt="" /></span> 
                    {/* <span className="text-sm dark:text-white"> Reassign</span> */}
                  </button>
                )}
                {is_resolved && (
                  <button
                    className="dash-action-link cursor-pointer"
                    onClick={() => setViewNotesDefect(row.original)}
                  >
                    <span className="text-sm dark:text-white"> View Notes</span>
                  </button>
                )}
              </div> :  is_resolved ? <div className="flex items-center gap-[8px]  theme_btn_item">
                <button
                title="View"
                  className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                  onClick={() => {
                    navigate("/goal_view", {
                      state: {
                        goalID: row.original.goal_id,
                        projectName: row.original.project_name,
                      },
                    });
                  }}
                >
                  <span className="text-sm dark:text-white"> <img src={viewIcon} className=" w-5 h-6 object-contain" alt="" /></span> 
                  {/* <span className="text-sm dark:text-white"> View</span> */}
                </button>
                <button
                  className="dash-action-link cursor-pointer"
                  onClick={() => setViewNotesDefect(row.original)}
                >
                  <span className="text-sm dark:text-white"> View Notes</span>
                </button>
              </div>  : <div className="flex items-center gap-[8px] theme_btn_item">
                {isCreating ? (
                  <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600" />
                    <span>Creating…</span>
                  </div>
                ) : (
                  <InputsDropdown
                    label=""
                    options={
                      goalExist ? getDefectActionOptionsGoalExist :
                     getDefectActionOptions
                    }
                    placeHolder={
                      row.original.action_type
                        ? row.original.action_type
                        : "Select action"
                    }
                    onSelect={(selectedOption: any) => {
                      const action = selectedOption;
                      if (action === "Resolve") {
                        setDefectResolveRow(row.original);
                      } else if (goalExist) {
                        navigate("/goal_view", {
                          state: {
                            goalID: row.original.goal_id,
                            projectName: row.original.project_name,
                          },
                        });
                      } else if (action === "Bug") {
                        handleCreatePodBugGoal(row.original);
                      } else if (action === "Enhancement") {
                          handleUpdateEnhancementDefect(row.original)
                      } else if (action === "Training Issue") {
                       setSelectedTrainingIssueRow(row.original);
                        setTrainingIssuePopupOpen(true);
                      } else if (action === "Follow-up") {
                        handleAutoCreateFollowupGoal(row.original);
                      } else {
                        navigate("/add_defect_task", {
                          state: {
                            defectID: row.original.id,
                            action: action,
                            reporter_name: row.original.reporter_name,
                            screen_name: row.original.screen_name,
                            agency_name: row.original.agency_name,
                            action_type: row.original.action_type,
                            description: row.original.description,
                            screen_members: row.original.screen_members,
                            fromPodName: row.original.pod_name,
                          },
                        });
                      }
                    }}
                  />
                )}
              </div>
            );
          },
        },
      ];
    }else if (label === "Demo Request") {
      return [
       
        {
          key: "name",
          name: "Name",
          id: "name",
          header: "Name",
          accessorKey: "name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
          cell: ({ row }: any) => {
            return (
              <div className="flex items-center gap-[8px]  theme_btn_item">
                <span
                  className="defact-click-item cursor-pointer"
                  onClick={() => setOpenDemo(row.original.id)}
                >
                  {row.original.name}
                </span>
              </div>
            );
          },
        },
        {
          key: "email",
          name: "Email",
          id: "email",
          header: "Email",
          accessorKey: "email",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "phone",
          name: "Phone",
          id: "phone",
          header: "Phone",
          accessorKey: "phone",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "agency_name",
          name: "Agency Name",
          id: "agency_name",
          header: "Agency Name",
          accessorKey: "agency_name",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any, columnId: any) => {
            const valueA = String(rowA.getValue(columnId) || "").toLowerCase();
            const valueB = String(rowB.getValue(columnId) || "").toLowerCase();
            return valueA.localeCompare(valueB);
          },
        },
        {
          key: "shifts",
          name: "Monthly Shift Vol.",
          id: "shifts",
          header: "Monthly Shift Vol.",
          accessorKey: "shifts",
          enableSorting: true,
        },
        {
          key: "payers",
          name: "Payer",
          id: "payers",
          header: "Payer",
          accessorKey: "payers",
          enableSorting: true,
        },
        {
          key: "created_at",
          name: "Submitted On",
          id: "created_at",
          header: "Submitted On",
          accessorKey: "created_at",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any) => {
            const a = new Date(rowA.getValue("created_at") || 0).getTime();
            const b = new Date(rowB.getValue("created_at") || 0).getTime();
            return a - b;
          },
        },
          {
          key: "demo_on",
          name: "Demo On",
          id: "demo_on",
          header: "Demo On",
          accessorKey: "demo_on",
          enableSorting: true,
          sortingFn: (rowA: any, rowB: any) => {
            const a = new Date(rowA.getValue("demo_on") || 0).getTime();
            const b = new Date(rowB.getValue("demo_on") || 0).getTime();
            return a - b;
          },
        },
        {
          key: "action",
          name: "Action",
          id: "action",
          header: "Action",
          accessorKey: "action",
          hideSearch: true,
          cell: ({ row }: any) => {
            return (
              <div className="flex items-center gap-[8px] theme_btn_item">
                {row.original.meeting_detail ?
                   (
                    <>
                    {
                      row.original?.meeting_detail?.meeting_id &&  <button
                    title="View"
                      className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                      onClick={() => {
                        navigate("/meeting_detail", {
                          state: {
                            meetingID: row.original?.meeting_detail?.meeting_id,
                            startMeetDate:
                              row.original?.meeting_detail?.start_datetime,
                            endMeetDate:
                              row.original?.meeting_detail?.end_datetime,
                          },
                        });
                      }}
                    >
                      <span className="text-sm dark:text-white"> <img src={viewIcon} className=" w-5 h-6 object-contain" alt="" /></span>
                      {/* <span className="text-sm dark:text-white"> View</span> */}
                    </button>
                    }
                   
                    {
                      row.original?.is_resolve ? (
                        <button
                          className="dash-action-link cursor-pointer"
                          onClick={() => {
                            const raw = row.original.resolve_data;
                            const parsed = raw
                              ? (typeof raw === "string" ? JSON.parse(raw) : raw)
                              : null;
                            setViewNotesDefect({
                              screen_name: row.original.name || row.original.agency_name,
                              resolutions: parsed
                                ? [{
                                    resolution_note: parsed.notes,
                                    resolved_by: parsed.resolved_by,
                                    resolved_on: parsed.date_time,
                                    file_url: parsed.attachment,
                                    file_name: parsed.attachment
                                      ? parsed.attachment.split("/").pop()
                                      : null,
                                  }]
                                : [],
                            });
                          }}
                        >
                          <span className="text-sm dark:text-white"> View Notes</span>
                        </button>
                      ) : (
                        <button
                        title="Resolve"
                          className="dash-action-link cursor-pointer viewbtn-tooltip-item"
                          onClick={() => setDemoResolveRow(row.original)}
                        >
                          <span className="text-sm dark:text-white"> <img src={resolvedIcon} className=" w-4 h-6 object-contain" alt="" /></span> 
                          {/* <span className="text-sm dark:text-white"> Resolve</span> */}
                        </button>
                      )
                    }
                    </>
                  ) : <button
                      className="dash-action-link cursor-pointer"
                      onClick={() => {
                        navigate('/add_meeting', {
                          state: {
                            preselectedMeetingType: "Demo Meeting",
                            agencyName: row.original.agency_name,
                            attendeeFullName: row.original.name,
                            attendeeEmail: row.original.email,
                            demoRequestId: row.original.id,
                            demoStartAt: row.original.demo_start_at || '',
                          },
                        });
                      }}
                    >
                      <span className="text-sm dark:text-white"> Demo</span>
                    </button>}
              </div>
            );
          },
        },
      ];
    }
    // Default columns if no specific alertLabel
    return [];
  };

  async function handleResolveClick() {
    if (dependencyToShow) {
      try {
        const response = await updateDependency({
          variables: {
            id: parseInt(dependencyToShow),
            is_resolved: true,
          },
        });
        if (response.data.update_dependency.status_code === 200) {
          showSuccess(response.data.update_dependency.message);
          setIsPopupOpen(false);
          setDependencyToShow("");
          getDependencies({
            variables: {
              page: 1,
              page_size: pageSize,
            },
          });
        }
        if (response.data.update_dependency.status_code === 400) {
          showError(response.data.update_dependency.message);
        }
      } catch (error) {
        if (error instanceof ApolloError) {
          showError(error.message);
        }
      }
    } else {
      showError("Please Try Again.");
    }
  }

          const [
        fetchPods,
    ] = useLazyQuery(PODS_DATA, {
        fetchPolicy: 'no-cache',
    });

  function getFilterInput(): string {
    switch (alertLabel) {
      case "Bugs":          return "Bug";
      case "Enhancements":  return "Enhancement";
      case "Follow Up":     return "Follow up";
      case "Training Issue": return "Training Issue";
      default:              return "Defects";
    }
  }


  async function handleCreatePodBugGoal(defectRow: any) {
  if (autoCreatingDefectId) return;

  setAutoCreatingDefectId(defectRow.id);
    const projectid = projects?.find((it:any) => it.name == defectRow?.project_name)?.key

  try {
    const today = format(new Date(), "yyyy-MM-dd");

    const response = await createPodGoal({
      variables: {
        pod_id: defectRow?.pod_id
          ? Number(defectRow.pod_id)
          : null,
title: defectRow?.agency_name && defectRow?.screen_name
  ? `Bug for ${defectRow.agency_name} on screen ${defectRow.screen_name}`
  : defectRow?.agency_name
    ? `Bug for ${defectRow.agency_name}`
    : defectRow?.screen_name
      ? `Bug on screen ${defectRow.screen_name}`
      : "Bug",
        action_type: "Bug",

        defect_id: defectRow?.id
          ? Number(defectRow.id)
          : null,

        description:
          defectRow?.description || "",

        start_date: today,
        task_assignees: null,
        template_tag: "bug-fix",
        project_id:Number(projectid)
      },
    });

    const result = response?.data?.create_pod_goal;

    if (result?.status_code === 200) {
      showSuccess(result.message || "Bug goal created successfully.");

      // Refresh defects table
      getDefects({
        variables: {
          page: currentPageRef.current,
          page_size: pageSize,
          is_confirmed: true,
          is_issue: true,
          is_resolved: false,
          filter_input: getFilterInput(),
        },
      });

      if (refetchCounter) {
        refetchCounter();
      }
    } else {
      showError(
        result?.message || "Failed to create bug goal."
      );
    }
  } catch (error) {
    if (error instanceof ApolloError) {
      showError(error.message);
    } else {
      showError("Failed to create bug goal. Please try again.");
    }
  } finally {
    setAutoCreatingDefectId(null);
  }
}

  async function handleAutoCreateCSOpsGoal(
    defectRow: any,
    opts: {
      goalFor: string;
      actionType: string;
      findGoalStatic: (data: any) => { id: string; name: string } | null;
      buildPayload: (params: {
        defect: any;
        podMembers: any[];
        podId: string;
        goalMasterData: any;
        goalStatic: { id: string; name: string };
        selectedSkills: { key: string; name: string }[];
        employeeID: string;
      }) => { goalData: any; error: null } | { goalData: null; error: string };
      goalNotFoundMsg: string;
      failMsg: string;
    },
  ) {
    if (autoCreatingDefectId) return;
    setAutoCreatingDefectId(String(defectRow.id));

    try {
      const today = format(new Date(), "yyyy-MM-dd");

      const [podsResult, goalsResult, skillsResult] = await Promise.all([
        fetchPods({
          variables: {
            agency_id: parseInt(agencyID),
            start_date: today,
            end_date: today,
          },
          fetchPolicy: "no-cache",
        }),
        client.query({
          query: GOAL_MASTER_DATA,
          variables: { goal_for: opts.goalFor },
          fetchPolicy: "no-cache",
        }),
        client.query({ query: GET_ALL_SKILLS, fetchPolicy: "no-cache" }),
      ]);

      const podName: string = defectRow.pod_name;
      const allPods: any[] = (podsResult.data?.pods_data?.data ?? []).filter(
        (p: any) => p.pod_name !== "All Pods",
      );
      const targetPod = allPods.find(
        (p: any) => p.pod_name?.toLowerCase() === podName.toLowerCase(),
      );
      if (!targetPod) {
        showError(`Pod "${podName}" not found. Please create the goal manually.`);
        return;
      }

      const goalStatic = opts.findGoalStatic(goalsResult.data);
      if (!goalStatic) {
        showError(opts.goalNotFoundMsg);
        return;
      }

      const allSkills: any[] = skillsResult.data?.get_all_skills?.skills ?? [];
      const selectedSkills = allSkills
        .filter((s: any) => DEFAULT_BUG_SKILL_NAMES.includes(s.skill_name))
        .map((s: any) => ({ key: String(s.id), name: s.skill_name }));

      const { goalData, error } = opts.buildPayload({
        defect: defectRow,
        podMembers: targetPod.members || [],
        podId: String(targetPod.pod_id),
        goalMasterData: goalsResult.data,
        goalStatic,
        selectedSkills,
        employeeID: String(employeeID),
      });

      if (error || !goalData) {
        showError(error ?? "Could not build goal payload.");
        return;
      }

      const response = await createGoal({ variables: { goal_data: goalData } });
      if (response.data.create_goal.status_code === 200) {
        const newGoalId = Number(response.data.create_goal?.goal?.id);
        console.log(opts,'opts')
        await patchDefect({
          variables: {
            id: defectRow.id,
            input: {
              is_goal_exist: true,
              goal_id: newGoalId,
              action_type: opts.actionType,
              project_name: "CareBravo",
            },
          },
        });

        showSuccess(response.data.create_goal.message);

        getDefects({
          variables: {
            page: currentPageRef.current,
            page_size: pageSize,
            is_confirmed: true,
            is_issue: true,
            is_resolved: false,
            filter_input: getFilterInput(),
          },
        });
        if (refetchCounter) refetchCounter();
      } else if (response.data.create_goal.status_code === 400) {
        showError(response.data.create_goal.message);
      }
    } catch (error) {
      if (error instanceof ApolloError) {
        showError(error.message);
      } else {
        showError(opts.failMsg);
      }
    } finally {
      setAutoCreatingDefectId(null);
    }
  }


async function handleCreatePodTrainingIssueGoal(
  defectRow: any,
  taskTag: string
) {
  if (autoCreatingDefectId) return;

  setAutoCreatingDefectId(defectRow.id);
    const projectid = projects?.find((it:any) => it.name == defectRow?.project_name)?.key
   
  try {
    const today = format(new Date(), "yyyy-MM-dd");

    const response = await createPodGoal({
      variables: {
            project_id:Number(projectid),
        pod_id: defectRow?.pod_id
          ? Number(defectRow.pod_id)
          : null,
title:
  defectRow?.agency_name && defectRow?.screen_name
    ? `Training for ${defectRow.agency_name} on screen ${defectRow.screen_name}`
    : defectRow?.agency_name
      ? `Training for ${defectRow.agency_name}`
      : defectRow?.screen_name
        ? `Training on screen ${defectRow.screen_name}`
        : "Training Issue",


        action_type: "Training Issue",
        defect_id: defectRow?.id
          ? Number(defectRow.id)
          : null,
        description:
          defectRow?.description || "",
        start_date: today,
        task_assignees: null,
        template_tag: "training-issue",
        ...(taskTag
  ? {
      task_tag: taskTag,
    }
  : {}),
      },
    });

    const result = response?.data?.create_pod_goal;

    if (result?.status_code === 200) {
      showSuccess(result.message || "Bug goal created successfully.");

      // Refresh defects table
      getDefects({
        variables: {
          page: currentPageRef.current,
          page_size: pageSize,
          is_confirmed: true,
          is_issue: true,
          is_resolved: false,
          filter_input: getFilterInput(),
        },
      });

      if (refetchCounter) {
        refetchCounter();
      }
    } else {
      showError(
        result?.message || "Failed to create bug goal."
      );
    }
  } catch (error) {
    if (error instanceof ApolloError) {
      showError(error.message);
    } else {
      showError("Failed to create bug goal. Please try again.");
    }
  } finally {
    setAutoCreatingDefectId(null);
  }
}

  async function handleAutoCreateFollowupGoal(defectRow: any) {
    return handleAutoCreateCSOpsGoal(defectRow, {
      goalFor: "Customer Success",
      actionType: "Follow up",
      findGoalStatic: findCustomerFollowupGoalStatic,
      buildPayload: (p) =>
        buildCustomerFollowupGoalPayload({
          defect: p.defect,
          podMembers: p.podMembers,
          podId: p.podId,
          goalMasterData: p.goalMasterData,
          customerFollowupGoalStatic: p.goalStatic,
          selectedSkills: p.selectedSkills,
          employeeID: p.employeeID,
        }),
      goalNotFoundMsg: "Customer Follow-up goal type not found in goal master data. Please create the goal manually.",
      failMsg: "Failed to create Customer Follow-up goal. Please try again.",
    });
  }


     async function handleCreatePodEnhancementGoal(defectRow: any) {
  if (autoCreatingDefectId) return;

  setAutoCreatingDefectId(defectRow.id);
    const projectid = projects?.find((it:any) => it.name == defectRow?.project_name)?.key
   
  try {
    const today = format(new Date(), "yyyy-MM-dd");

    const response = await createPodGoal({
      variables: {
        pod_id: defectRow?.pod_id
          ? Number(defectRow.pod_id)
          : null,
                  project_id:Number(projectid),

title:
  defectRow?.agency_name && defectRow?.screen_name
    ? `Enhancement for ${defectRow.agency_name} on screen ${defectRow.screen_name}`
    : defectRow?.agency_name
      ? `Enhancement for ${defectRow.agency_name}`
      : defectRow?.screen_name
        ? `Enhancement on screen ${defectRow.screen_name}`
        : "Enhancement",

        action_type: "Enhancement",
        defect_id: defectRow?.id
          ? Number(defectRow.id)
          : null,
        description:
          defectRow?.description || "",
        start_date: today,
        task_assignees: null,
        template_tag: "enhancements",
      },
    });

    const result = response?.data?.create_pod_goal;

    if (result?.status_code === 200) {
      showSuccess(result.message || "Bug goal created successfully.");

      // Refresh defects table
      getDefects({
        variables: {
          page: currentPageRef.current,
          page_size: pageSize,
          is_confirmed: true,
          is_issue: true,
          is_resolved: false,
          filter_input: getFilterInput(),
        },
      });

      if (refetchCounter) {
        refetchCounter();
      }
    } else {
      showError(
        result?.message || "Failed to create bug goal."
      );
    }
  } catch (error) {
    if (error instanceof ApolloError) {
      showError(error.message);
    } else {
      showError("Failed to create bug goal. Please try again.");
    }
  } finally {
    setAutoCreatingDefectId(null);
  }
}


     async function handleUpdateEnhancementDefect(defectRow: any) {
      const defectId = defectRow.id
      if (autoCreatingDefectId) return;

    setAutoCreatingDefectId(defectRow.id);
 
   
  try {


    const response = await updateDefect({
      variables: {
        input:{
        action_type: "Enhancement",
             title:
          "Enhancement" + " " + defectRow?.agency_name  +" " +defectRow?.screen_name ||
          defectRow?.title ||
          "Enhancement",
          created_by:parseInt(employeeID),
          is_issue:true,
          is_confirmed:true,
        },
        id: defectId
          ? Number(defectId)
          : null,

      },
    });

    const result = response?.data?.update_defect;

    if (result?.status_code === 200) {
      showSuccess(result.message );

      // Refresh defects table
      getDefects({
        variables: {
          page: currentPageRef.current,
          page_size: pageSize,
          is_confirmed: true,
          is_issue: true,
          is_resolved: false,
          filter_input: getFilterInput(),
        },
      });

      if (refetchCounter) {
        refetchCounter();
      }
    } else {
      showError(
        result?.message 
      );
    }
  } catch (error) {
    if (error instanceof ApolloError) {
      showError(error.message);
    } else {
      showError("Failed. Please try again.");
    }
  } finally {
    setAutoCreatingDefectId(null);
  }


     }




  async function handleReassignSave() {
    if (!reassignAlert || !reassignPod || !reassignActionType) return;
    setReassignSaving(true);

    const goalFor =
      reassignActionType === "Bug" || reassignActionType === "Enhancement"
        ? "Product Development"
        : "Customer Success";

    try {
      const today = format(new Date(), "yyyy-MM-dd");

      const [podsResult, goalsResult, skillsResult] = await Promise.all([
        fetchPods({
          variables: { agency_id: parseInt(agencyID), start_date: today, end_date: today },
          fetchPolicy: "no-cache",
        }),
        client.query({ query: GOAL_MASTER_DATA, variables: { goal_for: goalFor }, fetchPolicy: "no-cache" }),
        client.query({ query: GET_ALL_SKILLS, fetchPolicy: "no-cache" }),
      ]);

      const allPods: any[] = (podsResult.data?.pods_data?.data ?? []).filter(
        (p: any) => p.pod_name !== "All Pods",
      );
      const targetPod = allPods.find((p: any) => p.pod_id == reassignPod.pod_id);
      if (!targetPod) {
        showError(`Pod "${reassignPod.pod_name}" not found. Please try again.`);
        return;
      }

      const allSkills: any[] = skillsResult.data?.get_all_skills?.skills ?? [];
      const selectedSkills = allSkills
        .filter((s: any) => DEFAULT_BUG_SKILL_NAMES.includes(s.skill_name))
        .map((s: any) => ({ key: String(s.id), name: s.skill_name }));

      let goalData: any = null;
      let buildError: string | null = null;

      console.log(reassignAlert,'reassignAlert')

      if (reassignActionType === "Bug" && !reassignAlert?.is_template) {
        const goalStatic = findBugGoalStatic(goalsResult.data);
        if (!goalStatic) { showError("Bug goal type not found."); return; }
        const result = buildBugGoalPayload({
          defect: reassignAlert,
          podMembers: targetPod.members || [],
          podId: String(targetPod.pod_id),
          goalMasterData: goalsResult.data,
          bugGoalStatic: goalStatic,
          selectedSkills,
          employeeID: String(employeeID),
        });
        goalData = result.goalData;
        buildError = result.error;
      } else if (reassignActionType === "Enhancement" && !reassignAlert?.is_template) {
        const goalStatic = findEnhancementGoalStatic(goalsResult.data);
        if (!goalStatic) { showError("Enhancement goal type not found."); return; }
        const result = buildEnhancementGoalPayload({
          defect: reassignAlert,
          podMembers: targetPod.members || [],
          podId: String(targetPod.pod_id),
          goalMasterData: goalsResult.data,
          goalStatic,
          selectedSkills,
          employeeID: String(employeeID),
        });
        goalData = result.goalData;
        buildError = result.error;
      } else if (reassignActionType === "Training Issue" && !reassignAlert?.is_template) {
        const goalStatic = findTrainingIssueGoalStatic(goalsResult.data);
        if (!goalStatic) { showError("Training Issue goal type not found."); return; }
        const result = buildTrainingIssueGoalPayload({
          defect: reassignAlert,
          podMembers: targetPod.members || [],
          podId: String(targetPod.pod_id),
          goalMasterData: goalsResult.data,
          trainingIssueGoalStatic: goalStatic,
          selectedSkills,
          employeeID: String(employeeID),
        });
        goalData = result.goalData;
        buildError = result.error;
      } else if (reassignActionType === "Follow Up") {
        const goalStatic = findCustomerFollowupGoalStatic(goalsResult.data);
        if (!goalStatic) { showError("Follow Up goal type not found."); return; }
        const result = buildCustomerFollowupGoalPayload({
          defect: reassignAlert,
          podMembers: targetPod.members || [],
          podId: String(targetPod.pod_id),
          goalMasterData: goalsResult.data,
          customerFollowupGoalStatic: goalStatic,
          selectedSkills,
          employeeID: String(employeeID),
        });
        goalData = result.goalData;
        buildError = result.error;
      }

      if (buildError || !goalData && !reassignAlert?.is_template) {
        showError(buildError ?? "Could not build goal payload.");
        return;
      }
if(reassignAlert?.is_template){
  const response2 = await reassignDefectGoalPOD({
    variables: {
      goal_id: parseInt(reassignAlert.goal_id),
      new_pod_id: parseInt(targetPod.pod_id),
      action_type: reassignActionType,
      ...(reassignActionType === "Training Issue"
        ? { task_tag: reassignTaskTag }
        : {}),
    },
  });


      if (response2.data.reassign_pod_goal.status_code === 200) {
        setReassignAlert(null);
        showSuccess(response2.data.reassign_pod_goal.message);
        getDefects({
          variables: {
            page: currentPageRef.current,
            page_size: pageSize,
            is_confirmed: true,
            is_issue: true,
            is_resolved: false,
            filter_input: getFilterInput(),
          },
        });
        if (refetchCounter) refetchCounter();
      }else {
        showError(response2.data.reassign_pod_goal.message);
      }
      }else{
      const response = await reassignDefectGoal({
        variables: {
          defect_id: parseInt(reassignAlert.id),
          goal_data: goalData,
          new_action_type: reassignActionType === "Follow Up" ? "Follow up" : reassignActionType,
          new_pod_id: parseInt(targetPod.pod_id),
          created_by_name:userInfo ? `${userInfo.first_name} ${userInfo.last_name}` : null,
        },
      });
      if (response.data.reassign_defect_goal.status_code === 200) {
        setReassignAlert(null);
        showSuccess(response.data.reassign_defect_goal.message);
        getDefects({
          variables: {
            page: currentPageRef.current,
            page_size: pageSize,
            is_confirmed: true,
            is_issue: true,
            is_resolved: false,
            filter_input: getFilterInput(),
          },
        });
        if (refetchCounter) refetchCounter();
      } else {
        showError(response.data.reassign_defect_goal.message);
      }
      } 
    } catch (error) {
      if (error instanceof ApolloError) {
        showError(error.message);
      } else {
        showError("Failed to reassign. Please try again.");
      }
    } finally {
      setReassignSaving(false);
    }
  }

  async function handleDemoResolveSubmit(notes: string, fileUrl: string | null) {
    const data = demoResolveRow;
    if (!data) return;
    setDemoResolveLoading(true);

    const resolveData = {
      notes: notes || null,
      attachment: fileUrl || null,
      resolved_by: userInfo ? `${userInfo.first_name} ${userInfo.last_name}` : null,
      date_time: new Date().toISOString(),
    };

    try {
      const { error } = await getSupabaseExt()
        .from("carebravosite_contact_demo_requests")
        .update({ is_resolve: true, resolve_data: resolveData })
        .eq("id", data.id);
      if (!error) {
        setDemoResolveRow(null);
        showSuccess("Resolved successfully.");
        setDemoData((prev: any[]) =>
          prev.map((item: any) =>
            item.id === data.id
              ? { ...item, is_resolve: true, resolve_data: resolveData }
              : item
          )
        );
      } else {
        showError("Failed to resolve. Please try again.");
      }
    } catch (_) {
      showError("Failed to resolve. Please try again.");
    } finally {
      setDemoResolveLoading(false);
    }
  }

  async function handleBugResolveSubmit(notes: string, fileUrl: string | null) {
    const data = bugResolveDefect;
    if (!data) return;

         const is_resolved = data.is_resolved;
        const is_approved = data.is_approved;
        const customerApprovalSection = is_resolved && !is_approved

    try {
      const response = await resolveDefect({
        variables: {
          id: parseInt(data?.id),
          is_resolved: true,
          resolution_note: notes || undefined,
          file_url: fileUrl || undefined,
          resolved_by:parseInt(employeeID),
                 ...(customerApprovalSection && {
          is_approved: true
        }),
        },
      });
      if (response.data.resolve_defect.status_code === 200) {
        setBugResolveDefect(null);
        showSuccess(response.data.resolve_defect.message);
        setLoading(true);
        await fetch(
          "https://api.wizkind.com/wizkind-mobile-ai/wizkind-defect-close-email",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ defect_id: data.id }),
          },
        );
        setLoading(false);
        getDefects({
          variables: {
            page: currentPageRef.current,
            page_size: pageSize,
            is_confirmed: true,
            is_issue: true,
            is_resolved: bugStatusFilter === "All" ?  null : false,
            filter_input: "Bug",
                     ...((bugStatusFilter === "Customer Approval" || bugStatusFilter === "Closed") && {
            is_approved: bugStatusFilter === "Closed" ? true : false,
              is_resolved: true,
        }),
          },
        });
        refetchCounter();
      }
      if (response.data.resolve_defect.status_code === 400) {
        showError(response.data.resolve_defect.message);
      }
    } catch (error) {
      if (error instanceof ApolloError) {
        showError(error.message);
      } else {
        showError("Failed to resolve bug. Please try again.");
      }
    }
  }

  async function handleDefectResolveSubmit(notes: string, fileUrl: string | null) {
    const data = defectResolveRow;
    if (!data) return;
        const is_resolved = data.is_resolved;
        const is_approved = data.is_approved;
        const customerApprovalSection = is_resolved && !is_approved
    try {
      const response = await resolveDefect({
        variables: {
          id: parseInt(data?.id),
          is_resolved: true,
          resolution_note: notes || undefined,
          file_url: fileUrl || undefined,
          resolved_by: parseInt(employeeID),
                     ...(customerApprovalSection && {
          is_approved: true
        }),
        },
      });
      if (response.data.resolve_defect.status_code === 200) {
        setDefectResolveRow(null);
        showSuccess(response.data.resolve_defect.message);
        setLoading(true);
        await fetch("https://api.wizkind.com/wizkind-mobile-ai/wizkind-defect-close-email", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ defect_id: data.id }),
        });
        setLoading(false);
        console.log(getFilterInput(),'getFilterInput()')
        const checkstatus = getFilterInput() == "Training Issue" ?  trainingStatusFilter  : followUpStatusFilter
        getDefects({
          variables: {
            page: currentPageRef.current,
            page_size: pageSize,
            is_confirmed: true,
            is_issue: true,
            is_resolved: checkstatus === "All" ?  null : false,
            filter_input: getFilterInput(),
               ...((checkstatus === "Customer Approval" || checkstatus === "Closed") && {
            is_approved: checkstatus === "Closed" ? true : false,
              is_resolved: true,
        }),
          },
        });
        refetchCounter();
      }
      if (response.data.resolve_defect.status_code === 400) {
        showError(response.data.resolve_defect.message);
      }
    } catch (error) {
      if (error instanceof ApolloError) {
        showError(error.message);
      } else {
        showError("Failed to resolve defect. Please try again.");
      }
    }
  }

  async function handleEnhancementResolveSubmit(notes: string, fileUrl: string | null) {
    const data = enhancementResolveRow;
    if (!data) return;
          const is_resolved = data.is_resolved;
        const is_approved = data.is_approved;
        const customerApprovalSection = is_resolved && !is_approved
    try {
      const response = await resolveDefect({
        variables: {
          id: parseInt(data?.id),
          is_resolved: true,
          resolution_note: notes || undefined,
          file_url: fileUrl || undefined,
          resolved_by: parseInt(employeeID),
                     ...(customerApprovalSection && {
          is_approved: true
        }),
        },
      });
      if (response.data.resolve_defect.status_code === 200) {
        setEnhancementResolveRow(null);
        showSuccess(response.data.resolve_defect.message);
        setLoading(true);
        await fetch("https://api.wizkind.com/wizkind-mobile-ai/wizkind-defect-close-email", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ defect_id: data.id }),
        });
        setLoading(false);
        getDefects({
          variables: {
            page: currentPageRef.current,
            page_size: pageSize,
            is_confirmed: true,
            is_issue: true,
               is_resolved: enhancmentStatusFilter === "All" ?  null : false,
            filter_input: "Enhancement",
                 ...((enhancmentStatusFilter === "Customer Approval" || enhancmentStatusFilter === "Closed") && {
            is_approved: enhancmentStatusFilter === "Closed" ? true : false,
              is_resolved: true,
        }),
          },
        });
        refetchCounter();
      }
      if (response.data.resolve_defect.status_code === 400) {
        showError(response.data.resolve_defect.message);
      }
    } catch (error) {
      if (error instanceof ApolloError) {
        showError(error.message);
      } else {
        showError("Failed to resolve enhancement. Please try again.");
      }
    }
  }

  // Use useMemo to optimize the column generation
  const columns = useMemo(
    () => getColumns(alertLabel),
    [alertLabel, employeeID, assignedMemberOptions, autoCreatingDefectId, allPodsData,bugStatusFilter,enhancmentStatusFilter,trainingStatusFilter,followUpStatusFilter],
  );

  const formattedData = useMemo(() => {
    if (alertLabel === "Dependency") {
      if (dependencyData && dependencyData.dependencies.status_code === 200) {
        setTotalPages(dependencyData?.dependencies?.pagination.total_pages);
        const deps = dependencyData.dependencies.dependencies || [];
        return deps.map((d: any,index:any) => {
          // const caregiverName = `${d.last_name}, ${d.middle_name ? d.middle_name + ' ' : ''}${d.first_name}`;
          return {
            dependent_person_name: d.dependent_person_name,
            blocking_person_name: d.blocking_person_name,
            dependency_reason: d.dependency_reason,
            dependency_id: d.id,
            dependent_person_id: d.dependent_person_id,
            blocking_person_id: d.blocking_person_id,
            dependency_task_id: d?.task_id,
            dependency_date: format(d?.created_date, "MM-dd-yyyy"),
            action: "columns",
            

          };
        });
      }
    } else if (alertLabel === "Delays") {
      if (delaysData && delaysData.delays.status_code === 200) {
        setTotalPages(delaysData?.delays?.pagination.total_pages);
        const delays = delaysData.delays.tasks || [];
        return delays.map((d: any,index:any) => {
          const status = statusValues.find(
            (status) => status.id === d.current_status_id,
          );
          return {
            assigned_to_name: d.assigned_to_name,
            project_name: d.project_name,
            goal_name: d.goal_name,
            due_date: format(d?.end_datetime, "MM-dd-yyyy"),
            task_name: d.title,
            taskID: d.id,
            status: status ? status.name : "-",
            
            
          };
        });
      }
    } else if (alertLabel === "Defect") {
      if (defectsData && defectsData.defects.status_code === 200) {
        setTotalPages(defectsData?.defects?.pagination.total_pages);
        const defects = defectsData.defects.defects || [];
        return defects.map((d: any,index:any) => {
        const pod = allPodsData?.find((i:any) => i.pod_id == d.pod_id)
        const podName = pod?.pod_name
          return {
            ...d,
            title: d.title,
            severity: d.severity,
            created_on: format(d?.created_on, "MM-dd-yyyy"),
            id: d.id,
            pod_name:podName,
            
            pod_members:pod?.members,
          };
        });
      }
    } else if (
      alertLabel === "Upcoming Leave" ||
      alertLabel === "Today's Leave"
    ) {
      if (leavesData && leavesData?.leaves_by_agency?.status_code === 200) {
        setTotalPages(1);
        const upcomingLeaves = leavesData?.leaves_by_agency?.leaves || [];
        return upcomingLeaves.map((ul: any,index:any) => {
          return {
            employee_name: ul.employee_name,
            leave_type: ul.leave_type,
            leave_reason: ul.reason,
            status: ul.status,
            leave_date: format(new Date(ul.start_date), "MM-dd-yyyy"),
                

          };
        });
      }
    } else if (alertLabel === "Breaks") {
      if (breakData && breakData?.today_breaks_by_agency?.status_code === 200) {
        setTotalPages(1);
        const breaks = breakData?.today_breaks_by_agency?.clock_in_breaks || [];
        return breaks.map((b: any,index:any) => {
          return {
            employee_name: b.employee_name,
            start_time: format(new Date(b.start_time), "MM-dd-yyyy (h:mm a)"),
                          
          };
        });
      }
    } else if (alertLabel === "Upcoming Features") {
      if (
        upcomingFeaturesData &&
        upcomingFeaturesData.upcoming_features.status_code === 200
      ) {
        setTotalPages(
          upcomingFeaturesData?.upcoming_features?.pagination.total_pages,
        );
        const upcomingFeatures =
          upcomingFeaturesData.upcoming_features.goals || [];
        return upcomingFeatures.map((uf: any,index:any) => {
          // const status = statusValues.find(status => status.id === d.current_status_id);
          return {
            goal_name: uf?.title,
            project_name: uf?.project_name,
            release_date: format(new Date(uf?.end_date), "MM-dd-yyyy"),
            status: uf?.goal_status,
            goal_id: uf?.id,
              
            // goal_members: uf?.
          };
        });
      }
    } else if (alertLabel === "Bugs") {
      if (defectsData && defectsData.defects.status_code === 200) {
        setTotalPages(defectsData?.defects?.pagination.total_pages);
        const defects = defectsData.defects.defects || [];
        return defects.map((d: any,index:any) => {
              const pod = allPodsData?.find((i:any) => i.pod_id == d.pod_id)
        const podName = pod?.pod_name
          return {
            ...d,
            title: d.title,
            severity: d.severity,
            created_on: format(d?.created_on, "MM-dd-yyyy"),
            id: d.id,
             pod_name:podName,
              
              pod_members:pod?.members
          };
        });
      }
    } else if (alertLabel === "Enhancements") {
      if (defectsData && defectsData.defects.status_code === 200) {
        setTotalPages(defectsData?.defects?.pagination.total_pages);
        const defects = defectsData.defects.defects || [];
        return defects.map((d: any,index:any) => {
         const pod = allPodsData?.find((i:any) => i.pod_id == d.pod_id)
        const podName = pod?.pod_name
    
          return {
            ...d,
            title: d.title,
            severity: d.severity,
            created_on: format(d?.created_on, "MM-dd-yyyy"),
            id: d.id,
               pod_name:podName,
              
             pod_members:pod?.members
          };
        });
      }
    } else if (alertLabel === "Follow Up") {
      if (defectsData && defectsData.defects.status_code === 200) {
        setTotalPages(defectsData?.defects?.pagination.total_pages);
        const defects = defectsData.defects.defects || [];
        return defects.map((d: any,index:any) => {
         const pod = allPodsData?.find((i:any) => i.pod_id == d.pod_id)
        const podName = pod?.pod_name
    
          return {
            ...d,
            title: d.title,
            severity: d.severity,
            created_on: format(d?.created_on, "MM-dd-yyyy"),
            id: d.id,
               pod_name:podName,
              
             pod_members:pod?.members
          };
        });
      }
    } else if (alertLabel === "Training Issue") {
      if (defectsData && defectsData.defects.status_code === 200) {
        setTotalPages(defectsData?.defects?.pagination.total_pages);
        const defects = defectsData.defects.defects || [];
        return defects.map((d: any,index:any) => {
         const pod = allPodsData?.find((i:any) => i.pod_id == d.pod_id)
        const podName = pod?.pod_name
    
          return {
            ...d,
            title: d.title,
            severity: d.severity,
            created_on: format(d?.created_on, "MM-dd-yyyy"),
            id: d.id,
               pod_name:podName,
              
             pod_members:pod?.members
          };
        });
      }
    }else if (alertLabel === "Demo Request") {
      const PAGE_SIZE = pageSize;
      const filtered = demoData.filter((d: any) => {
        if (demoFilter === "Open") return !d.is_resolve;
        if (demoFilter === "Closed") return d.is_resolve === true;
        return true;
      });
      setTotalPages(Math.ceil(filtered.length / PAGE_SIZE));
      const start = (currentPage - 1) * PAGE_SIZE;
      return filtered.slice(start, start + PAGE_SIZE).map((d: any,index:any) => ({
        ...d,
        name: d.name ?? d.full_name ?? "-",
        email: d.email ?? "-",
        company: d.company ?? d.company_name ?? "-",
        phone: d.phone ?? formatPhoneNumber(d.phone_number) ?? "-",
        message: d.message ?? d.notes ?? "-",
        created_at: d.created_at
          ? format(new Date(d.created_at), "MM-dd-yyyy")
          : "-",
                
         demo_on: d.demo_start_at
  ? format(new Date(d.demo_start_at), "MM-dd-yyyy hh:mm a")
  : "-",
      }));
    } else {
      return [];
    }
  }, [
    dependencyData,
    delaysData,
    defectsData,
    leavesData,
    breakData,
    upcomingFeaturesData,
    demoData,
    demoFilter,
    currentPage,
    pageSize,
    allPodsData
  ]);

  function handlePageSizeChange(size: number) {
    setPageSize(size);
    paginationhandle(1, undefined, size);
  }

  function paginationhandle(pageNo: number, _itemsPerPage?: number, size?: number) {
    const ps = size ?? pageSize;
    setCurrentPage(pageNo);

    if (alertLabel === "Dependency") {
      getDependencies({
        variables: {
          page: pageNo,
          page_size: ps,
        },
      });
    } else if (alertLabel === "Delays") {
      getDelays({
        variables: {
          date: todayDate,
          page: pageNo,
          page_size: ps,
        },
      });

      // setAlertOrAction("action")
      setAlertOrAction("alert");
    } else if (alertLabel === "Defect") {
      getDefects({
        variables: {
          page: pageNo,
          page_size: ps,
          is_confirmed: true,
          is_issue: true,
          is_resolved: false,
          filter_input: "Defects",
        },
      });

      // setAlertOrAction("action")
      setAlertOrAction("alert");
    } else if (alertLabel === "Upcoming Features") {
      const paginationInput = {
        page: pageNo,
        page_size: ps,
      };

      getUpcomingFeatures({
        variables: {
          outcome: ["Build Something New"],
          pagination_input: paginationInput,
        },
      });

      // setAlertOrAction("action")
      setAlertOrAction("alert");
    } else if (alertLabel === "Bugs") {
      getDefects({
        variables: {
          page: pageNo,
          page_size: ps,
          is_confirmed: true,
          is_issue: true,
          is_resolved: bugStatusFilter === "All" ? null : bugStatusFilter === "Open" ? false : true,
          filter_input: "Bug",
             ...((bugStatusFilter === "Customer Approval" || bugStatusFilter === "Closed") && {
          is_approved: bugStatusFilter === "Closed" ? true : false,
        }),
        },
      });

      setAlertOrAction("alert");
    } else if (alertLabel === "Enhancements") {
      getDefects({
        variables: {
          page: pageNo,
          page_size: ps,
          is_confirmed: true,
          is_issue: true,
          is_resolved: enhancmentStatusFilter === "All" ? null : enhancmentStatusFilter === "Open" ? false : true,
          filter_input: "Enhancement",
                ...((enhancmentStatusFilter === "Customer Approval" || enhancmentStatusFilter === "Closed") && {
          is_approved: enhancmentStatusFilter === "Closed" ? true : false,
        }),
        },
      });

      setAlertOrAction("alert");
    } else if (alertLabel === "Follow Up") {
      getDefects({
        variables: {
          page: pageNo,
          page_size: ps,
          is_confirmed: true,
          is_issue: true,
          is_resolved: followUpStatusFilter === "All" ? null : followUpStatusFilter === "Open" ? false : true,
          filter_input: "Follow up",
                   ...((followUpStatusFilter === "Customer Approval" || followUpStatusFilter === "Closed") && {
          is_approved: followUpStatusFilter === "Closed" ? true : false,
        }),
        },
      });

      setAlertOrAction("alert");
    } else if (alertLabel === "Training Issue") {
      getDefects({
        variables: {
          page: pageNo,
          page_size: ps,
          is_confirmed: true,
          is_issue: true,
          is_resolved: trainingStatusFilter === "All" ? null : trainingStatusFilter === "Open" ? false : true,
          filter_input: "Training Issue",
                  ...((trainingStatusFilter === "Customer Approval" || trainingStatusFilter === "Closed") && {
          is_approved: trainingStatusFilter === "Closed" ? true : false,
        }),
        },
      });

      setAlertOrAction("alert");
    } else if (alertLabel === "Demo Request") {
      // all data already in demoData; formattedData slices by currentPage
    }
  }

  function handleAddClick() {
    if (alertLabel === "Dependency") {
      navigate("/add_dependency", {
        state: {
          taskID: null,
        },
      });
    } else if (alertLabel === "Defect") {
      navigate("/add_defect");
    } else if (
      alertLabel === "Today's Leave" ||
      alertLabel === "Upcoming Leave"
    ) {
      navigate("/apply_leave");
    } else if (alertLabel === "Bugs") {
      navigate("/add_bug");
    } else if (alertLabel === "Enhancements") {
      navigate("/add_enhancement");
    }
  }

  useEffect(() => {
  const isAnyPopupOpen =
    isPopupOpen ||
    !!openDefectEmail ||
    !!openDemo ||
    !!bugResolveDefect ||
    !!defectResolveRow ||
    !!enhancementResolveRow ||
    !!demoResolveRow ||
    !!viewNotesDefect ||
    !!reassignAlert ||
    trainingIssuePopupOpen ||
    reassignTrainingIssuePopupOpen;

  if (isAnyPopupOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }

  return () => {
    document.body.style.overflow = "";
  };
}, [
  isPopupOpen,
  openDefectEmail,
  openDemo,
  bugResolveDefect,
  defectResolveRow,
  enhancementResolveRow,
  demoResolveRow,
  viewNotesDefect,
  reassignAlert,
  trainingIssuePopupOpen,
  reassignTrainingIssuePopupOpen,
]);

  return (
    <>
      <div className="dashboard-status-dv self-stretch shadow-[2px_2px_32px_rgba(0,_19,_85,_0.08)] rounded-lg bg-surface-bg-primary box-border overflow-hidden flex flex-col items-start justify-start max-w-full text-surface-error border-[1px] border-solid border-surface-border">
        <div
          className={`scroll_custom_blg_dv  flex flex-col items-start justify-start max-w-full text-black min-w-full dashnorad_doc_exprince ${alertOrAction === "alert" ? "alert-dashboard-dv" : "actions-dashboard-dv"}`}
        >
          {userInfo?.access_type !== "Admin" &&
          userInfo?.access_type !== "Owner" ? (
            <div className="lightdoc-tabel-head-dv self-stretch bg-surface-bg-red overflow-hidden flex flex-row items-center justify-start py-[15px] px-4 box-border min-w-full mq991:min-w-[99px]">
              <div className="flex-1 flex flex-row items-center justify-start gap-[10px] max-w-full">
                <b className="flex-1 text-xl-dv relative text-black inline-block max-w-[calc(100%_-_34px)] dark:text-white">
                  {alertLabel}
                </b>
                {alertLabel !== "Delays" &&
                  alertLabel !== "Breaks" &&
                  alertLabel !== "Bugs" &&
                  alertLabel !== "Enhancements" &&
                  alertLabel !== "Demo Request" && alertLabel !== "Follow Up" && alertLabel !== "Training Issue" && alertLabel !== "Upcoming Features"  && (
                    <div
                      onClick={handleAddClick}
                      className="cursor-pointer flex flex-col items-start justify-start p-[10px] plus-task-btn taskdash-plush-img rounded"
                    >
                      <img
                        className="w-4 h-4 relative overflow-hidden shrink-0"
                        loading="lazy"
                        alt=""
                        src={ioniconaaddoutline}
                      />
                    </div>
                  )}
              </div>
            </div>
          ) : (
            <div className="lightdoc-tabel-head-dv self-stretch bg-surface-bg-red overflow-hidden dark:bg-slate-800 flex flex-row items-center justify-start py-[15px] px-4 box-border min-w-full mq991:min-w-[99px]">
              <div className="flex-1 flex flex-row items-center justify-start gap-[10px] max-w-full">
                <img
                  className="h-6 w-6 flagtimenone-img relative overflow-hidden shrink-0 min-h-[24px]"
                  alt=""
                  src={iioniconaalertcircleoutline}
                />
                <img
                  className="h-6 w-6 flag-action-img relative hidden overflow-hidden shrink-0 min-h-[24px]"
                  alt=""
                  src={firsflag1}
                />
                <b className="flex-1 relative text-black inline-block max-w-[calc(100%_-_34px)] dark:text-white">
                  {alertLabel}
                </b>
              </div>
            </div>
          )}
        {/* Status filter pills for Bugs, Enhancements, Demo Request, Follow Up, and Training Issue */}
{(
  alertLabel === "Bugs" ||
  alertLabel === "Enhancements" ||
  alertLabel === "Demo Request" ||
  alertLabel === "Follow Up" ||
  alertLabel === "Training Issue"
) && (
  <div className="self-stretch flex flex-row flex-wrap items-center gap-[6px] px-4 pt-3 pb-1">
    {(alertLabel === "Demo Request"
      ? ["All", "Open", "Closed"]
      : ["All", "Open", "Customer Approval", "Closed"]
    ).map((status) => {
      const activeFilter =
        alertLabel === "Bugs"
          ? bugStatusFilter
          : alertLabel === "Enhancements"
          ? enhancmentStatusFilter
          : alertLabel === "Follow Up"
          ? followUpStatusFilter
          : alertLabel === "Training Issue"
          ? trainingStatusFilter
          : demoFilter;

      return (
        <button
          key={status}
          type="button"
          onClick={() => {
            if (alertLabel === "Bugs") {
              setBugStatusFilter(status);
            } else if (alertLabel === "Enhancements") {
              setEnhancmentStatusFilter(status);
            } else if (alertLabel === "Follow Up") {
              setFollowUpStatusFilter(status);
            } else if (alertLabel === "Training Issue") {
              setTrainingStatusFilter(status);
            } else {
              setDemoFilter(status);
            }
          }}
          className={`cursor-pointer text-xs font-semibold px-3 py-1 rounded-full border transition-colors ${
            activeFilter === status
              ? "bg-surface-primary-surface text-white border-surface-primary-surface"
              : "bg-white dark:bg-slate-700 text-gray-600 dark:text-gray-300 border-surface-border hover:border-surface-primary-surface"
          }`}
        >
          {status}
        </button>
      );
    })}
  </div>
)}
          {dependencyDataLoading ||
          updateDependencyLoading ||
          delaysDataLoading ||
          resolveDefectLoading ||
          defectsDataLoading ||
          leavesDataLoading ||
          breakDataLoading ||
          upcomingFeaturesLoading ||
          loading ||
  
          demoLoading ||
          reassignMutationLoading || reassignMutationLoadingPOD ? (
            <div className="p-4 w-full">
              <SkeletonLoader count={5} height="h-10" className="mb-2" />
            </div>
          ) : formattedData?.length > 0 ? (
            <DynamicTable
              filteredData={formattedData}
              selectedColumns={columns}
              sorting={sorting}
              setSorting={setSorting}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
              setMainTable={setMainTable}
              setMainTableUpdate={setMainTableUpdate}
              currentPage={currentPage}
              totalPages={totalPages}
              handlePageChange={paginationhandle}
              showPagination={true}
              paginationDataLength={totalPages > 1 || currentPage != 1}
              pageSize={pageSize}
              onPageSizeChange={handlePageSizeChange}
              serialNumber={true}
            />
          ) : (
            <div className="self-stretch rounded-lg  overflow-hidden rounded-lg flex flex-col items-center justify-center py-[20px] px-[20px] gap-[8px] text-center text-text-text-secondary mq450:pl-5 mq450:pr-5 mq450:box-border">
              <div className="self-stretch bg-white rounded-lg bg-slate-100 overflow-hidden dark:bg-slate-700 flex flex-col items-center justify-center py-[110px] px-[53px] gap-[8px] text-center text-text-text-secondary mq450:pl-5 mq450:pr-5 mq450:box-border">
                <img
                  className="w-9 h-9 relative overflow-hidden shrink-0"
                  alt=""
                  src={
                    alertOrAction === "action"
                      ? firsflag1
                      : iioniconaalertcircleoutline
                  }
                />
                <p className="relative my-0">No data available</p>
              </div>
            </div>
          )}
        </div>
      </div>

      {isPopupOpen && (
        <NotifyPopup
          onsubmit={handleResolveClick}
          back={() => {
            setIsPopupOpen(false);
          }}
          isDelete={false}
          showMessage={"Dependency is resolved."}
        />
      )}
      <DefectEmailModal
        defectsData={defectsData}
        isOpen={openDefectEmail}
        onClose={() => setOpenDefectEmail("")}
      />

      {/* currently using this for demo alert */}
      <BugModal
        demoData={demoData}
        isOpen={openDemo}
        onClose={() => setOpenDemo("")}
      />

      <BugResolveModal
        defect={bugResolveDefect}
        isOpen={!!bugResolveDefect}
        onClose={() => setBugResolveDefect(null)}
        onSubmit={handleBugResolveSubmit}
        isResolving={resolveDefectLoading}
        title={"Bug"}
      />

      <BugResolveModal
        defect={defectResolveRow}
        isOpen={!!defectResolveRow}
        onClose={() => setDefectResolveRow(null)}
        onSubmit={handleDefectResolveSubmit}
        isResolving={resolveDefectLoading}
        title={"Defect"}
      />

      <BugResolveModal
        defect={enhancementResolveRow}
        isOpen={!!enhancementResolveRow}
        onClose={() => setEnhancementResolveRow(null)}
        onSubmit={handleEnhancementResolveSubmit}
        isResolving={resolveDefectLoading}
        title={"Enhancement"}
      />

      <BugResolveModal
        defect={demoResolveRow}
        isOpen={!!demoResolveRow}
        onClose={() => setDemoResolveRow(null)}
        onSubmit={handleDemoResolveSubmit}
        isResolving={demoResolveLoading}
        title={"Demo Request"}
      />

      {/* Read-only Resolution Notes popup */}
      {viewNotesDefect && (
        <div
          className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4"
          onClick={(e) => { if (e.target === e.currentTarget) setViewNotesDefect(null); }}
        >
          <div className="bg-white dark:bg-gray-800 rounded-md shadow-2xl w-full max-w-[560px] bugresolved-main-model">
            <div className="flex items-start justify-between px-6 pt-5 pb-4 border-b border-gray-100 dark:border-gray-700">
              <div className="grid gap-2">
                <h2 className="font-bold text-xl-dv text-black dark:text-white my-0">Resolution Notes</h2>
                {viewNotesDefect.screen_name && (
                  <p className="text-sm text-gray-500 dark:text-gray-400 my-0">{viewNotesDefect.screen_name}</p>
                )}
              </div>
              <button
                type="button"
                onClick={() => setViewNotesDefect(null)}
                className="text-gray-400 cta-red transition mt-0.5 ml-4 flex-shrink-0 pt-1"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-6 grid gap-4 max-h-[60vh] overflow-y-auto">
              {(viewNotesDefect.resolutions ?? []).length === 0 ? (
                <p className="text-sm text-gray-500 dark:text-gray-400">No resolution notes available.</p>
              ) : (
                (viewNotesDefect.resolutions ?? []).map((res: any, idx: number) => {
                  const resolverName =
                    assignedMemberOptions.find((e) => e.key === String(res.resolved_by))?.name ??
                    res.resolved_by ??
                    "—";
                                   const aprroverName =
                    assignedMemberOptions.find((e) => e.key === String(res.approved_by))?.name ??
                    res.approved_by ??
                    "";
                  const resolvedOn = res.resolved_on
                    ? format(new Date(res.resolved_on), "MMM dd, yyyy hh:mm a")
                    : "—";

                                      const approvedOn = res.approved_on
                    ? format(new Date(res.approved_on), "MMM dd, yyyy hh:mm a")
                    : "";
                  return (
                    <div key={res.id ?? idx} className="grid gap-3">
                      <div className="grid grid-cols-2 mq1400:grid-2 mq1275:grid-cols-2 mq950:mq1275:grid-cols-2 mq575:mq1275:grid-cols-1  gap-[8px] min-w-full">
                        <div className="grid gap-1">
                          <label className="self-stretch relative font-semibold dark:text-white">Resolved by</label>
                          <div className="inputborder_css_dv mt-id-dv self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] dark:bg-slate-700 border-[1px] border-solid  border-surface-border undefined ">
                           <span className="text-sm text-black dark:text-white">{resolverName}</span>
                          </div>
                        </div>
                        <div className="grid gap-1">
                          <label className="self-stretch relative font-semibold dark:text-white">Resolved on</label>
                          <div className="inputborder_css_dv mt-id-dv self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] dark:bg-slate-700 border-[1px] border-solid  border-surface-border undefined ">
                            <span className="text-sm text-black dark:text-white">{resolvedOn}</span>
                          </div>
                          
                        </div>
                      </div>
                      {res.resolution_note && (
                        <div className="grid gap-1">
                    
                           <label className="self-stretch relative font-semibold dark:text-white">Notes</label>
                           <div className="inputborder_css_dv mt-id-dv self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] dark:bg-slate-700 border-[1px] border-solid  border-surface-border undefined ">
                         <p className="text-sm text-black dark:text-white bg-gray-50 dark:bg-gray-700 rounded-md my-0 whitespace-pre-wrap">
                            {res.resolution_note}
                          </p>
                           </div>
                         
                        </div>
                      )}
                      {res.file_url && (
                        <div className="grid gap-1">
                    
                           <label className="self-stretch relative font-semibold dark:text-white">Attachment</label>
                          <a
                            href={res.file_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                            className="text-sm text-blue-600 dark:text-blue-400 hover:underline flex items-center gap-1"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                            </svg>
                            {res.file_name ?? "Download attachment"}
                          </a>
                        </div>
                      )}
                           <div className="grid grid-cols-2 mq1400:grid-2 mq1275:grid-cols-2 mq950:mq1275:grid-cols-2 mq575:mq1275:grid-cols-1  gap-[8px] min-w-full">
                            {
                              aprroverName &&
                          <div className="grid gap-1">
                          <label className="self-stretch relative font-semibold dark:text-white">Approved by</label>
                          <div className="inputborder_css_dv mt-id-dv self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] dark:bg-slate-700 border-[1px] border-solid  border-surface-border undefined ">
                            <span className="text-sm text-black dark:text-white">{aprroverName}</span>
                          </div>
                        </div>
                            }
                   
                   {
                    approvedOn && 
                                            <div className="grid gap-1">
                          <label className="self-stretch relative font-semibold dark:text-white">Approved on</label>
                          <div className="inputborder_css_dv mt-id-dv self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] dark:bg-slate-700 border-[1px] border-solid  border-surface-border undefined ">
                             <span className="text-sm text-black dark:text-white">{approvedOn}</span>
                          </div>
                        </div>
                   }
                      </div>



                                                {res.approved_notes && (
                        <div className="grid gap-1">
                          <label className="self-stretch relative font-semibold dark:text-white">Customer Approval Notes</label>
                          <div className="inputborder_css_dv mt-id-dv self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] dark:bg-slate-700 border-[1px] border-solid  border-surface-border undefined ">
                               <p className="text-sm text-black dark:text-white bg-gray-50 dark:bg-gray-700 rounded-md my-0 whitespace-pre-wrap">
                            {res.approved_notes}
                          </p>
                          </div>
                         
                        </div>
                      )}
                             {res.approved_file_url && (
                        <div className="grid gap-1">
                          <span className="text-xs font-semibold text-gray-500 dark:text-gray-400">Attachment</span>
                          <a
                            href={res.approved_file_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                            className="text-sm text-blue-600 dark:text-blue-400 hover:underline flex items-center gap-1"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                            </svg>
                            {res.file_name ?? "Download attachment"}
                          </a>
                        </div>
                      )}
                    </div>
                  );
                })
              )}
            </div>

            <div className="px-6 pb-5 flex justify-end">
              <button
                type="button"
                onClick={() => setViewNotesDefect(null)}
                className="red-clockout-btn red-clockout-btn-items cursor-pointer [border:none] py-2.5 h-[44px] px-[42px] mq575:h-[35px] mq575:py-[12.5px] mq575:px-[25px] bg-green-500 rounded-radiuscomponent-button flex flex-row items-center justify-center gap-[12px] "
              >
                <span className="text-sm font-body-xs-semi-bold text-surface-bg-primary">Close</span>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* <EnhancementModal
        enhancementData={enhancementData}
        isOpen={openEnhanceDetail}
        onClose={() => setOpenEnhanceDetail("")}
      /> */}




            {trainingIssuePopupOpen && (
  <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50">
    <div className="w-[400px] rounded-lg bg-white p-6 dark:bg-gray-800 grid gap-4">
     <div className="flex items-start justify-between  pb-0 border-b border-gray-100">
       <h2 className=" mb-0 my-0 font-bold text-xl-dv text-black dark:text-white">
        Select Training Issue Action
      </h2>
      <button    onClick={() => {
          setTrainingIssuePopupOpen(false);
          setSelectedTrainingIssueRow(null);
        }} className="text-gray-400 cta-red transition mt-0.5 ml-4 flex-shrink-0 pt-1" aria-label="Close">
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg></button>
     </div>

      <div className="flex flex-col gap-3">
        {TRAINING_ISSUE_TASK_OPTIONS.map((option) => (
          <button
            key={option.key}
            type="button"
            className="rounded-md border px-4 py-3 text-left hover:bg-gray-100 dark:hover:bg-gray-700 clockout-button-item-dv"
            onClick={() => {
              setTrainingIssuePopupOpen(false);

              handleCreatePodTrainingIssueGoal(
                selectedTrainingIssueRow,
                option.key
              );

              setSelectedTrainingIssueRow(null);
            }}
          >
            {option.name}
          </button>
        ))}
      </div>

      {/* <div className="self-stretch flex flex-row items-center justify-end py-0 pr-0 gap-[8px] mq950:box-border mq1425:flex-wrap  mq1425:box-border mq450:box-border">
        <button
        type="button"
        className="cursor-pointer bg-white py-2.5 h-[44px] mq575:h-[35px] px-[42px] btn-text-purple mq575:py-[12.5px] mq575:px-[25px] rounded-radiuscomponent-button box-border flex flex-row items-center justify-center gap-[12px] border-[2px] border-solid border-surface-primary-surface hover:bg-gainsboro-100 hover:box-border hover:border-[2px] hover:border-solid hover:border-dodgerblue"
        onClick={() => {
          setTrainingIssuePopupOpen(false);
          setSelectedTrainingIssueRow(null);
        }}
      >
        Cancel
      </button>
      </div> */}
    </div>
  </div>
)}

      {reassignAlert && (
        <div
          className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 z-[9999] p-4"
          onClick={(e) => { if (e.target === e.currentTarget) { setReassignAlert(null);
setHistoryOpen(false);
setReassignTaskTag("");
setReassignTrainingIssuePopupOpen(false); } }}
        >
          <div className="bg-white dark:bg-gray-800 rounded-md shadow-2xl w-full min-w-[1200px] mq991:min-w-[inherit] max-w-[500px] bugresolved-main-model">
            {/* Header */}
            <div className="flex items-center justify-between px-6 pt-5 pb-4 border-b border-gray-100 dark:border-gray-700">
              <h2 className="font-bold text-xl-dv text-black dark:text-white my-0">Reassign Alert</h2>
              <button
                type="button"
                onClick={() => { setReassignAlert(null);
setHistoryOpen(false);
setReassignTaskTag("");
setReassignTrainingIssuePopupOpen(false); }}
                className="text-gray-400 cta-red transition mt-0.5 ml-4 flex-shrink-0 pt-1"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Tabs */}
            <div className="flex border-b border-gray-100 dark:border-gray-700 gap-2 px-6">
              <button
                type="button"
                onClick={() => setHistoryOpen(false)}
                className={` py-2.5 text-sm  transition border-b-2 ${
                  !historyOpen
                    ? "relative link-filterSvgrepo-dv cursor-pointer inactive_item_blgs  active_item_blgs"
                    : "relative link-filterSvgrepo-dv cursor-pointer inactive_item_blgs  "
                }`}
              >
                Reassign
              </button>
              <button
                type="button"
                onClick={() => {
                  setHistoryOpen(true);
                  getDefectHistory({ variables: { defect_id: parseInt(reassignAlert.id) } });
                }}
                className={` py-2.5 text-sm  transition border-b-2 ${
                  historyOpen
                    ? "relative link-filterSvgrepo-dv cursor-pointer inactive_item_blgs  active_item_blgs"
                    : "relative link-filterSvgrepo-dv cursor-pointer inactive_item_blgs  "
                }`}
              >
                History
              </button>
            </div>

            {/* Reassign form */}
            {!historyOpen && (
              <>
             <div className="p-6 grid gap-5 dropdown-dark-input">
  <div className="grid gap-1.5">
    <label className="text-xs font-semibold text-gray-500 dark:text-gray-400">Pod</label>
    <InputsDropdown
      label=""
      options={
        (allPodsData ?? [])
          .filter((p: any) => p.pod_name !== "All Pods")
          .map((p: any) => ({ key: String(p.pod_id), name: p.pod_name }))
      }
      placeHolder={reassignPod?.pod_name || "Select pod"}
      onSelect={(selectedKey: any) => {
        const pod = (allPodsData ?? []).find((p: any) => String(p.pod_id) === selectedKey);
        setReassignPod(pod || null);
      }}
    />
  </div>

  <div className="grid gap-1.5 dropdown-dark-input">
    <label className="text-xs font-semibold text-gray-500 dark:text-gray-400">Action Type</label>
    <InputsDropdown
      label=""
      options={[
        { key: "Bug", name: "Bug" },
        { key: "Enhancement", name: "Enhancement" },
        { key: "Training Issue", name: "Training Issue" },
      ]}
      placeHolder={reassignActionType || "Select action type"}
      onSelect={(selectedKey: any) => {
        setReassignActionType(selectedKey);
        setReassignTaskTag(""); // reset task when action type changes
      }}
    />
  </div>

  {reassignActionType === "Training Issue" && (
    <div className="grid gap-1.5 dropdown-dark-input">
      <label className="text-xs font-semibold text-gray-500 dark:text-gray-400">Task</label>
      <InputsDropdown
        label=""
        options={TRAINING_ISSUE_TASK_OPTIONS}
        placeHolder={
          TRAINING_ISSUE_TASK_OPTIONS.find((o) => o.key === reassignTaskTag)?.name ||
          "Select task"
        }
        onSelect={(selectedKey: any) => setReassignTaskTag(selectedKey)}
      />
    </div>
  )}
</div>

                <div className="px-6 pb-5 flex items-center justify-end gap-3 border-t border-gray-100 dark:border-gray-700 pt-4">
                  <button
                    type="button"
                    disabled={reassignSaving}
                    onClick={() => { setReassignAlert(null);
setHistoryOpen(false);
setReassignTaskTag("");
setReassignTrainingIssuePopupOpen(false); }}
                    className="cursor-pointer py-2 px-5 rounded-md border border-gray-300 dark:border-gray-600 text-sm font-semibold text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 transition disabled:opacity-50"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    disabled={
    reassignSaving ||
    !reassignPod ||
    !reassignActionType ||
    (reassignActionType === "Training Issue" && !reassignTaskTag)
  }

                    onClick={handleReassignSave}
                    className="cursor-pointer py-2 px-5 rounded-md text-sm font-semibold text-white bg-surface-primary-surface hover:bg-dodgerblue transition disabled:opacity-50 flex items-center gap-2"
                  >
                    {reassignSaving ? (
                      <>
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white" />
                        <span>Saving...</span>
                      </>
                    ) : (
                      <span>Save</span>
                    )}
                  </button>
                </div>
              </>
            )}


            {/* History panel */}
            {historyOpen && (
              <>
                <div className="p-6 grid gap-4 max-h-[60vh] overflow-y-auto reassign-history-item-dv">
                  {historyLoading ? (
                    <SkeletonLoader count={3} height="h-24" className="mb-2" />
                  ) : (historyData?.defect_history?.history ?? []).length === 0 ? (
                    <p className="text-sm text-gray-500 dark:text-gray-400 text-center py-8">
                      No Reassign History Found.
                    </p>  
                  ) : (
                    [...(historyData.defect_history.history as any[])]
                      .sort((a, b) => new Date(b.changed_on).getTime() - new Date(a.changed_on).getTime())
                      .map((item: any, idx: number) => (
                        <div key={item.id ?? idx} className="grid gap-3 pb-4 border-b border-gray-100 dark:border-gray-700 last:border-0 last:pb-0 ">
                         
                          <div className="grid grid-cols-4 mq1400:grid-4 mq1275:grid-cols-3 mq950:grid-cols-2 mq575:grid-cols-1 gap-[8px] min-w-full">
                             <div className="grid gap-0.5">
                              <label className="self-stretch relative font-semibold dark:text-white">Reassigned By</label>
                              <div className="inputborder_css_dv mt-id-dv self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] dark:bg-slate-700 border-[1px] border-solid  border-surface-border undefined ">
                               <span className="text-sm text-black dark:text-white">{item.changed_by ?? "-"}</span>
                              </div>
                             
                            </div>
                            <div className="grid gap-0.5">
                              <label className="self-stretch relative font-semibold dark:text-white">Date</label>
                              <div className="inputborder_css_dv mt-id-dv self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] dark:bg-slate-700 border-[1px] border-solid  border-surface-border undefined ">
                                   <span className="text-sm text-black dark:text-white">
                              {item.changed_on
    ? format(parseAsUTC(item.changed_on), "dd MMM yyyy, hh:mm a")
    : "-"}    </span>
                              </div>
                             
                            </div>
                            <div className="grid gap-0.5">
                              <label className="self-stretch relative font-semibold dark:text-white">Old POD</label>
                              <div className="inputborder_css_dv mt-id-dv self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] dark:bg-slate-700 border-[1px] border-solid  border-surface-border undefined ">
                                   <span className="text-sm text-black dark:text-white">
                                {item.old_pod_id
                                  ? (allPodsData?.find((p: any) => p.pod_id == item.old_pod_id)?.pod_name ?? String(item.old_pod_id))
                                  : "-"}
                              </span>
                              </div>
                             
                            </div>
                            <div className="grid gap-0.5">
                              <label className="self-stretch relative font-semibold dark:text-white">New POD</label>
                              <div className="inputborder_css_dv mt-id-dv self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] dark:bg-slate-700 border-[1px] border-solid  border-surface-border undefined ">
                                      <span className="text-sm text-black dark:text-white">
                                {item.new_pod_id
                                  ? (allPodsData?.find((p: any) => p.pod_id == item.new_pod_id)?.pod_name ?? String(item.new_pod_id))
                                  : "-"}
                              </span>
                              </div>
                              
                            </div>
                            <div className="grid gap-0.5">
                              <label className="self-stretch relative font-semibold dark:text-white">Old Action</label>
                              <div className="inputborder_css_dv mt-id-dv self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] dark:bg-slate-700 border-[1px] border-solid  border-surface-border undefined ">
                                     <span className="text-sm text-black dark:text-white">{item.old_action_type ?? "-"}</span>
                              </div>
                             
                            </div>
                            <div className="grid gap-0.5">
                              <label className="self-stretch relative font-semibold dark:text-white">New Action</label>
                              <div className="inputborder_css_dv mt-id-dv self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] dark:bg-slate-700 border-[1px] border-solid  border-surface-border undefined ">
                                    <span className="text-sm text-black dark:text-white">{item.new_action_type ?? "-"}</span>
                              </div>
                              
                            </div>
                          </div>
                          <div className="grid grid-cols-1 mq1400:grid-1 mq1275:grid-cols-1 mq950:grid-cols-1 mq575:grid-cols-1 gap-[8px] min-w-full">
                            <label className="self-stretch relative font-semibold dark:text-white">Summary</label>
                             <div className="inputborder_css_dv mt-id-dv self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] dark:bg-slate-700 border-[1px] border-solid  border-surface-border undefined ">
                            <p className="text-sm text-black dark:text-white bg-gray-50 dark:bg-gray-700 rounded-md p-3 my-0 whitespace-pre-wrap">
                              {item.summary ?? "-"}
                            </p>
                              </div>
                            
                          </div>
                        </div>
                      ))
                  )}
                </div>

                <div className="px-6 pb-5 flex justify-end border-t border-gray-100 dark:border-gray-700 pt-4">
                  <button
                    type="button"
                    onClick={() => { setReassignAlert(null);
setHistoryOpen(false);
setReassignTaskTag("");
setReassignTrainingIssuePopupOpen(false); }}
                    className="cursor-pointer py-2.5 h-[44px] px-[42px] bg-surface-primary-surface rounded-radiuscomponent-button flex items-center justify-center hover:bg-dodgerblue [border:none]"
                  >
                    <span className="text-sm font-body-xs-semi-bold text-surface-bg-primary">Close</span>
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};
export default DashAlert;
